const dict = {
  uk: {
    dashboard: {
      lingvishSpace: 'LINGVISH SPACE',
      navProfile: 'Профіль',
      navSchedule: 'Розклад',
      navClubs: 'Клуби',
      navChat: 'Чат',
      navAiChat: 'Практика з Кеном',
      navAiChatShort: 'Кен',
      exit: 'Вийти',
      childAccountNotFound: 'Дитячий акаунт не знайдено',
      backButton: 'Повернутися',
      downloadReport: 'Завантажити звіт',
      pdfLearningReport: 'PDF звіт навчання',
      linkAccount: 'Прив\'язати акаунт',
      linkAccountDesc: 'Запросити батька або іншого',
      reportModalTitle: 'Завантажити звіт',
      reportModalIntro: 'Оберіть місяць для генерації звіту. Звіт міститиме інформацію про заняття, домашні завдання, оцінки та досягнення.',
      month: 'Місяць',
      reportLanguage: 'Мова звіту',
      ukrainian: 'Українська',
      english: 'English',
      reportContains: 'Звіт міститиме:',
      contentLessons: 'Кількість занять за місяць',
      contentHomework: 'Виконані та невиконані домашні завдання',
      contentReview: 'Оцінки за review',
      contentCancelled: 'Скасовані заняття',
      generating: 'Генерація...',
      download: 'Завантажити',
      successTitle: 'Успішно',
      reportDownloaded: 'Звіт завантажено!',
      errorTitle: 'Помилка',
      reportFailed: 'Не вдалося згенерувати звіт',
      passwordChangeError: 'Помилка зміни пароля',
      passwordChanged: 'Пароль успішно змінено',
      profileDeleted: 'Профіль успішно видалено',
      connectionError: 'Помилка з\'єднання',
      profileDeleteError: 'Помилка видалення профілю',
      completeRegistrationTitle: 'Завершіть реєстрацію',
      completeRegistrationSubtitle: 'Розкажіть трохи про себе та пройдіть тест рівня, щоб отримати персоналізоване навчання.',
      completeRegistrationCta: 'Завершити реєстрацію',
    },
    profileTab: {
      happyBirthday: 'Happy Birthday, {{name}}! 🎂',
      festiveModeSubtitle: 'Святковий режим профілю на 24 години',
      myStars: 'Мої зірочки',
      topUp: 'Поповнити',
      starHistory: 'Історія зірочок',
      englishLevel: 'Рівень англійської',
      continueTest: 'Продовжити тест ({{done}}/{{total}})',
      completeTestPersonalized: 'Завершіть тест для персоналізованого навчання',
      takeTestForLevel: 'Пройдіть тест для визначення рівня',
      completeTest: 'Завершити тест',
      takeTest: 'Пройти тест',
      family: 'Сім\'я',
      linkAccount: 'Прив\'язати акаунт',
      linkAccountEmpty: 'Прив\'яжіть акаунт вашої дитини, щоб бачити її прогрес, або прив\'яжіть батьківський акаунт для керування навчанням',
      yearsOld: 'років',
      testPassed: 'Тест пройдено',
      testNotPassed: 'Тест не пройдено',
      currency: 'грн',
      manage: 'Керування',
      enterProfile: 'Перейти',
      enterChildFailed: 'Не вдалося увійти в профіль дитини',
      adultAccount: 'Дорослий акаунт',
      addChildTitle: 'Додати дитину',
      childFullName: 'Повне ім\'я дитини',
      childFullNamePlaceholder: 'Наприклад: Софія Коваль',
      loginNickname: 'Нікнейм для входу',
      nicknamePlaceholder: 'Наприклад: sofia_kid',
      nicknameHint: 'Латинські літери, цифри та _ (дитина буде входити з цим нікнеймом)',
      email: 'Електронна пошта',
      emailPlaceholder: 'Наприклад: sofia@example.com',
      emailHint: 'Пошта прив\'язується до дитячого акаунту (для відновлення доступу)',
      age: 'Вік',
      agePlaceholder: 'Від 3 до 17 років',
      password: 'Пароль',
      passwordPlaceholder: 'наприклад, kotik7',
      passwordHint: '. Дитина буде використовувати цей пароль для входу.',
      cancel: 'Скасувати',
      add: 'Додати',
      loadingHistory: 'Завантаження…',
      noHistoryYet: 'Історії ще немає',
      reasonLessonStars: 'Нагорода за урок',
      reasonPurchaseStars: 'Купівля зірочок',
      reasonKenSkin: 'Купівля скіна для Кена',
      reasonAdminGrant: 'Нарахування від адміністратора',
      reasonOperation: 'Операція',
      close: 'Закрити',
      deleteProfileTitle: 'Видалити профіль?',
      deleteProfileMsg: 'Ви впевнені, що хочете видалити свій профіль? Цю дію неможливо скасувати.',
      delete: 'Видалити',
      convertToAdultTitle: 'Перевести на дорослий акаунт?',
      convertToAdultMsg: 'Перевести {{name}} на дорослий акаунт? Цю дію не можна скасувати.',
      convert: 'Перевести',
      deleteChildTitle: 'Видалити акаунт дитини?',
      deleteChildMsg: 'Видалити акаунт дитини {{name}}? Всі дані будуть втрачені.',
      needVerifiedEmail: 'Потрібен підтверджений email',
      convertEmailWarning: 'Перш ніж {{name}} стане самостійним акаунтом, вона має зайти у свій профіль, {{action}}. Без цього не буде як входити та відновлювати пароль.',
      addEmail: 'додати email і підтвердити його',
      verifyEmail: 'підтвердити email',
      childCreateError: 'Помилка створення дитячого акаунту',
      nicknameTaken: 'Цей нікнейм вже зайнятий. Оберіть інший.',
      emailTaken: 'Цей email вже зайнятий. Оберіть інший.',
      connectionTryLater: 'Помилка з\'єднання. Спробуйте пізніше.',
      convertAccountError: 'Помилка переведення акаунту',
      deleteAccountError: 'Помилка видалення акаунту',
    },
    scheduleTab: {
      schedule: 'Розклад',
      homework: 'Домашні завдання',
      homeworkShort: 'ДЗ',
      repetition: 'Повторення',
      moduleTests: 'Модульні тести',
      testsShort: 'Тести',
      scheduleTitle: 'Розклад занять',
      vacation: 'Канікули!',
      noLessonsThisDay: 'Уроки в цей день не проводяться',
      firstLessonAwaits: 'Ваш перший урок чекає!',
      pickTeacherFormat: 'Оберіть зручний час, викладача та формат навчання',
      enrollInLesson: 'Записатися на урок',
      individually: 'Індивідуально',
      group: 'Групові',
      noPlannedLessons: 'Немає запланованих уроків на цей день',
      vacationTooltip: 'Канікули',
      vacationClubTooltip: 'Канікули (є заняття клубу)',
      movieClub: 'Movie Club',
      bookClub: 'Book Club',
      grammarClub: 'Grammar Club',
      speakingClub: 'Speaking Club',
      individualLesson: 'Індивідуальний урок',
      groupLesson: 'Групове заняття',
      paidByPromo: 'Оплачено промокодом',
      paidByReschedule: 'Оплачено при перенесенні',
      paidBySeries: 'Перший урок серії — оплачено при старті',
      paidByCompensation: 'Оплачено як компенсація за форс-мажор викладача',
      paidInAdvance: 'Оплачено наперед',
      paid: 'Оплачено',
      clubSession: 'Заняття клубу',
      awaitingPayment: 'Очікує оплати',
      topUpDeadline: 'Поповніть баланс ({{price}} грн) до {{deadline}}',
      topUpBalance: 'Поповнити баланс',
      join: 'Приєднатися',
      reschedule: 'Перенести',
      cancel: 'Скасувати',
      cancelLessonPenalty: 'До уроку залишилось менше 4 годин. При скасуванні кошти не повертаються. Бажаєте скасувати?',
      cancelLessonConfirm: 'Ви впевнені, що хочете скасувати урок?',
      cancelLessonQuotaExceeded: 'Ви вже використали всі безкоштовні скасування цього місяця ({{max}} з {{max}}). Це скасування буде платним — кошти за урок не повертаються. Бажаєте скасувати?',
      freeCancellationsLeft: 'Безкоштовних скасувань цього місяця залишилось: {{remaining}} з {{max}}',
      no: 'Ні',
      confirm: 'Підтвердити',
      yesCancel: 'Так, скасувати',
      cancelledByStudent: 'Скасовано студентом',
      requestSentToParent: 'Запит надіслано батьку. Очікуй підтвердження.',
      configureLearning: 'Налаштувати навчання',
      lessonHistory: 'Історія занять',
      groupRecordingsTitle: 'Записи групових занять',
      groupRecordingsMissed: 'Пропущено',
      groupRecordingsWatch: 'Дивитись',
      groupRecordingsPart: 'Частина {{n}}',
      rules: 'Правила',
      enrollInLessonBtn: 'Записатися на заняття',
      homeworkTitle: 'Домашні завдання',
      tabNew: 'Нові',
      tabOverdue: 'Прострочені',
      tabCompleted: 'Виконані',
      exercisesLbl: 'вправ',
      pointsLbl: 'балів',
      deadline: 'Дедлайн',
      deadlineWas: 'Дедлайн був',
      complete: 'Виконати',
      completeLate: 'Виконати (буде здано невчасно)',
      noActiveHw: 'Немає активних домашніх завдань',
      noOverdueHw: 'Немає прострочених завдань',
      noCompletedHw: 'Немає виконаних домашніх завдань',
      overdueTag: 'Прострочено',
      submittedLate: 'Здано невчасно',
      result: 'Результат',
      completedOn: 'Виконано',
      review: 'Переглянути',
      repetitionTitle: 'Повторення',
      passingScore: 'Прохідний',
      timeLimit: 'Ліміт',
      questionsCount: 'завдань',
      pointsCount: 'балів',
      minutesLimit: 'хв',
      starting: 'Запуск...',
      startTest: 'Розпочати тест',
      noModuleTests: 'Немає доступних модульних тестів',
      testsAppearWhen: 'Тести з\'являться, коли вчитель прив\'яже їх до модулів вашої програми',
    },
    repetitionPath: {
      start: 'Старт',
      waitNextLesson: 'Зачекай наступного уроку',
      lessonNotAssigned: 'Урок ще не призначений',
      noRepetitionGames: 'Ігор для повторення поки немає',
      tasksAppearAfterLesson: 'Завдання з\'являться після першого уроку',
      memory: 'Memory',
      labelledDiagram: 'Labelled Diagram',
      pairOrNoPair: 'Pair or No Pair',
      listenType: 'Listen & Type',
      listenPick: 'Listen & Pick',
      sorting: 'Sorting',
      dictation: 'Диктант',
    },
    childPending: {
      title: 'Мої запити',
      cancelRequest: 'Скасувати запит',
      loadFailed: 'Не вдалося завантажити запити',
      cancelFailed: 'Не вдалося скасувати',
      parentSaid: 'Батько',
      response: 'відповідь',
      statusPending: 'Очікує батька',
      statusApproved: 'Схвалено',
      statusRejected: 'Відхилено',
      statusCancelled: 'Скасовано',
      statusExpired: 'Прострочено',
    },
    childPermissions: {
      canJoinClub: 'Записуватися на клуби',
      canJoinClubHint: 'Купівля одноразового запису на клуб',
      canBuyClubSub: 'Купувати абонемент на клуби',
      canBuyClubSubHint: 'Пакет із 4 або 8 занять',
      canCancelLesson: 'Скасовувати заняття',
      canRescheduleLesson: 'Переносити заняття',
      canPayKen: 'Оплачувати "Практику з Кеном"',
      canPayKenHint: 'Підписка на AI-практику',
      canMakePurchases: 'Робити покупки в магазині',
      canTakeVacation: 'Брати канікули',
      canFreezeStudies: 'Заморожувати навчання',
      loadFailed: 'Не вдалося завантажити дозволи',
      saveFailed: 'Не вдалося зберегти',
      enabled: 'увімкнено',
      disabled: 'вимкнено',
      explanation: 'Якщо повзунок',
      explanationWhenOn: ', дитина виконує дію самостійно. Якщо',
      explanationWhenOff: '— натискання на кнопку створює запит, який ви побачите тут і зможете схвалити або відхилити.',
    },
    parentApprovals: {
      title: 'Запити від дітей',
      filterPending: 'Очікують',
      filterApproved: 'Схвалені',
      filterRejected: 'Відхилені',
      filterAll: 'Усі',
      statusPending: 'Очікує',
      statusApproved: 'Схвалено',
      statusRejected: 'Відхилено',
      statusCancelled: 'Скасовано',
      statusExpired: 'Прострочено',
      noRequestsYet: 'Запитів поки немає',
      from: 'Від',
      yourComment: 'Ваш коментар',
      commentPlaceholder: 'Коментар (необов\'язково)',
      approve: 'Схвалити',
      reject: 'Відхилити',
      expiredText: 'Термін дії запиту минув',
      loadFailed: 'Не вдалося завантажити запити',
      processFailed: 'Не вдалося обробити запит',
    },
    linkAccount: {
      title: 'Прив\'язати акаунт',
      tabSend: 'Надіслати',
      tabIncoming: 'Вхідні',
      tabOutgoing: 'Мої запити',
      infoText: 'Введіть email акаунту, з яким хочете встановити зв\'язок. Зміна вступить в силу лише після підтвердження з іншого боку.',
      linkType: 'Тип зв\'язку',
      linkAsChild: 'Прив\'язати як мою дитину',
      linkAsParent: 'Прив\'язати як мого батька',
      unlink: 'Розірвати зв\'язок',
      linkAsChildDesc: 'Інший акаунт стане моєю дитиною (я керую дозволами)',
      linkAsParentDesc: 'Інший акаунт стане моїм батьком (керує мною)',
      unlinkDesc: 'Розірвати наявний зв\'язок',
      otherEmail: 'Email іншої сторони',
      messageLabel: 'Повідомлення',
      messageOptional: '(необов\'язково)',
      sent: 'Запит надіслано. Очікуй на підтвердження.',
      sendRequest: 'Надіслати запит',
      noRequests: 'Запитів немає',
      from: 'Від',
      to: 'До',
      accept: 'Прийняти',
      reject: 'Відхилити',
      cancel: 'Скасувати',
      childEmailNotVerified: 'Дитячий акаунт має спочатку зайти у свій профіль, додати email і підтвердити його. Лише після цього можна розірвати зв\'язок.',
      loadFailed: 'Не вдалося завантажити запити',
      sendFailed: 'Не вдалося надіслати запит',
      processFailed: 'Не вдалося обробити запит',
      verifyEmailTitle: 'Підтвердьте email для відв\'язки',
      verifyEmailDesc: 'Перш ніж стати самостійним акаунтом, потрібно мати підтверджений email — щоб ви могли заходити та відновлювати пароль.',
      statusPending: 'Очікує підтвердження',
      statusAccepted: 'Прийнято',
      statusRejected: 'Відхилено',
      statusCancelled: 'Скасовано',
      statusExpired: 'Прострочено',
    },
    emailVerify: {
      title: 'Підтвердження email',
      email: 'Email',
      emailHint: 'Email буде збережено у вашому профілі. Після підтвердження ви зможете відв\'язатися від батьківського акаунту.',
      codeLabel: 'Код підтвердження',
      resendCode: 'Надіслати код ще раз',
      saveAndSend: 'Зберегти й надіслати код',
      verify: 'Підтвердити',
      codeSent: 'Код надіслано на вашу пошту',
      sendFailed: 'Не вдалося надіслати код',
      invalidEmail: 'Введіть коректний email',
      saveFailed: 'Не вдалося зберегти email',
      enter6Digit: 'Введіть 6-значний код',
      invalidCode: 'Невірний код',
    },
    aiChat: {
      trialLeft: 'Безкоштовний період: залишилось {{days}} {{word}}.',
      subscriptionMonthly: 'Вартість підписки на місяць — {{price}} грн.',
      subscribeNow: 'Оформити зараз',
      close: 'Закрити',
      trialEnded: 'Безкоштовний період завершився.',
      subscribe: 'Оформити підписку',
      videoCallTitle: 'Video call',
      videoCallLocked: 'Оформи підписку, щоб дзвонити Кену',
      videoCallStart: 'Start video call with Ken',
      historyFail: 'Не вдалось завантажити історію чату.',
      subscribeFailed: 'Не вдалось оформити підписку. Спробуй ще раз.',
      requestSentToParent: 'Запит надіслано батьку. Очікуй підтвердження.',
      tooFast: 'Ти пишеш дуже швидко. Зачекай хвилинку.',
      kenBusy: 'Ken трохи зайнятий. Спробуй за хвилину.',
      cannotGetReply: 'Не вдалось отримати відповідь. Спробуй ще раз.',
      retryIn: 'Спробуй знову через {{seconds}} с.',
      subscribeToWrite: 'Оформи підписку, щоб писати Кену...',
      waitSeconds: 'Зачекай {{seconds}} с...',
      writeInEnglish: 'Write to Ken in English...',
      subscribeSubTitle: 'Оформити підписку',
      practiceWithKen: 'Практика з Кеном',
      trialDaysLeft: 'Залишилось {{days}} {{word}} безкоштовного періоду',
      trialEndedSubtitle: 'Безкоштовний період завершився',
      priceLine: '{{price}} грн',
      forDays: '/ {{days}} днів',
      benefit1: 'Безліміт повідомлень Кену',
      benefit2: 'Відеодзвінки з Кеном',
      benefit3: 'Корекція граматики в реальному часі',
      balanceLbl: 'Баланс',
      notEnoughAmount: 'Не вистачає {{amount}} грн. Поповни рахунок у профілі.',
      later: 'Пізніше',
      subscribeBtn: 'Оформити',
      explanation: 'Пояснення',
      dayOne: 'день',
      dayFew: 'дні',
      dayMany: 'днів',
    },
    kenCall: {
      trialEndedCall: 'Безкоштовний період завершився. Оформи підписку у чаті.',
      micPermission: 'Дозволь доступ до мікрофона у браузері і спробуй знову.',
      practiceWithKen: 'Practice with Ken',
    },
    prepaidLessons: {
      title: 'Оплачені заняття',
      lessonOne: 'заняття',
      lessonFew: 'заняття',
      lessonMany: 'занять',
      breakdownPromo: 'Промокод',
      breakdownSeries: 'Перше заняття серії',
      empty: 'Наразі немає передплачених занять',
      hint: 'Кількість наступних занять, за які не буде списано з балансу',
      paid: 'оплачених',
    },
    promo: {
      title: 'Промокод',
      placeholder: 'Введіть код',
      activate: 'Активувати',
      hint: 'Активуйте промокод, щоб отримати бонус на баланс або безкоштовні заняття',
      activateFailed: 'Не вдалося активувати промокод',
      clubPromoWrongContext: 'Спочатку оберіть заняття клубу, на яке хочете записатися — промокод на клуб вводиться у вікні бронювання.',
      connectionError: 'Помилка з\'єднання',
      close: 'Закрити',
      activated: 'Промокод активовано!',
      lessonsCredited: 'Нараховано {{count}} безкоштовних {{word}}. Наступні {{count}} — за наш рахунок.',
      clubLessonsCredited: 'Нараховано {{count}} безкоштовних {{word}} клубу. Наступні {{count}} відвідування — за наш рахунок.',
      balanceCredited: 'Нараховано {{amount}} грн на ваш баланс',
      awesome: 'Чудово',
    },
    starPurchase: {
      title: 'Поповнити зірочки',
      yourBalance: 'Ваш баланс',
      currentStars: 'Зараз зірочок',
      rate: 'Курс',
      howMany: 'Скільки зірочок купити?',
      toPay: 'До сплати',
      notEnoughBalance: 'Недостатньо коштів на балансі',
      networkError: 'Помилка мережі',
      buyFailed: 'Не вдалось купити зірочки',
      processing: 'Обробка…',
      buy: 'Купити',
    },
    reschedule: {
      title: 'Перенести заняття',
      currentTime: 'Поточний час',
      freeLimitUsed: 'Ліміт безкоштовних перенесень цього місяця ({{max}}) вичерпано. За перенесення цього заняття буде знято подвійну плату — {{amount}} грн (за скасоване заняття та передоплата за нове). Якщо не бажаєте оплачувати подвійну вартість — просто завчасно скасуйте заняття без перенесення на іншу дату.',
      freeLeft: 'Безкоштовних перенесень цього місяця: {{remaining}} з {{max}}',
      loading: 'Завантаження…',
      noSlots: 'На найближчі 14 днів немає вільних слотів у цього викладача.',
      cancel: 'Скасувати',
      moving: 'Переносимо…',
      moveBtn: 'Перенести',
      insufficient: 'Недостатньо коштів. Потрібно {{need}} грн, на балансі {{balance}} грн. Поповніть баланс.',
      confirmPaid: 'Підтвердіть платне перенесення',
      confirmPaidText: 'При перенесенні цього заняття буде знято подвійну оплату:',
      forNewLesson: 'За проведене заняття ({{time}})',
      forCancelled: 'За скасоване заняття ({{time}})',
      total: 'Всього',
      confirmPaidNote: 'Ліміт безкоштовних перенесень ({{max}}) на цей місяць вичерпано. При скасуванні перенесеного заняття ≥ 4 год до початку {{price}} грн переносяться як оплата наступного заняття серії (оплата за скасований слот не повертається).',
      payAndMove: 'Оплатити {{amount}} грн і перенести',
      requestSentToParent: 'Запит надіслано батьку. Очікуй підтвердження.',
      insufficientBalance: 'Недостатньо коштів. Поповніть баланс.',
    },
    replacement: {
      title: 'Заміна викладача',
      needDecision: 'Потрібне рішення по перенесених уроках',
      slotsCount: 'У {{count}} {{word}} ваш звичайний викладач зайнятий. Оберіть заміну або пропустіть.',
      slotOne: 'слоту',
      slotMany: 'слотах',
      choose: 'Обрати',
      teacherBusy: 'Звичайний викладач ({{teacher}}) зайнятий на цей слот.',
      substitute: 'Заміна',
      substituteDesc: 'Провести на цей слот з іншим вільним викладачем.',
      skip: 'Пізніше',
      skipDesc: 'Пропустити цей слот. Урок додасться далі зі своїм викладачем.',
      searching: 'Шукаємо доступних викладачів…',
      noSubs: 'Доступних викладачів на цей слот немає — оберіть «Пізніше».',
      pickTeacher: '— оберіть викладача —',
      pickSubstitute: 'Оберіть викладача для заміни',
      saving: 'Зберігаємо…',
      confirm: 'Підтвердити',
    },
    teacherLeave: {
      title: 'Рішення по уроках',
      teacherOnLeave: 'Ваш викладач буде відсутній',
      teacherOnLeaveVacation: 'Ваш викладач буде у відпустці',
      teacherOnLeaveSick: 'Ваш викладач на лікарняному',
      teacherOnLeaveForceMajeure: 'У вашого викладача форс-мажор',
      teacherOnLeaveDayOff: 'У вашого викладача вихідний',
      needDecisionForLessons: 'Потрібно прийняти рішення по {{count}} {{word}}: пауза, заміна або перенесення.',
      lessonOne: 'уроку',
      lessonMany: 'уроках',
      choose: 'Обрати',
      teacher: 'Викладач',
      pause: 'Пауза',
      pauseDesc: 'Пропустити урок. Кредит зберігається, програма посунеться.',
      substitute: 'Заміна',
      substituteDesc: 'Провести з іншим викладачем. Програма йде далі.',
      reschedule: 'Перенести',
      rescheduleDesc: 'Обрати інший вільний час у цього ж викладача. Безкоштовно.',
      searching: 'Шукаємо доступних викладачів…',
      noSubs: 'Доступних викладачів на цей слот немає. Доступна лише пауза.',
      pickTeacher: '— оберіть викладача —',
      applyToRest: 'Застосувати до решти уроків цієї відпустки',
      pickSubstitute: 'Оберіть викладача для заміни',
      saving: 'Зберігаємо…',
      confirm: 'Підтвердити',
    },
    lessonHistory: {
      title: 'Історія занять',
      filter: 'Фільтр',
      filterAll: 'Всі',
      filterIndividual: 'Індивідуальні',
      filterGroup: 'Групові',
      empty: 'Історія занять порожня',
      minutes: 'хв',
      teacher: 'Вчитель',
      group: 'Група',
      individualLesson: 'Індивідуальне заняття',
      groupLesson: 'Групове заняття',
      statusCompleted: 'Завершено',
      statusScheduled: 'Заплановано',
      statusCancelledOnTime: 'Скасовано вчасно',
      statusCancelledLate: 'Скасовано пізно',
      statusCancelledNoFunds: 'Скасовано (нестача коштів)',
      statusMissed: 'Пропущено',
      statusTeacherNoShow: 'Неявка вчителя',
      statusTeacherShort: 'Неповний урок',
      statusBothNoShow: 'Обопільна неявка',
      showing: 'Показано {{from}}-{{to}} з {{total}}',
      back: 'Назад',
      forward: 'Вперед',
    },
    shop: {
      title: 'Магазин навчальних матеріалів',
      searchPlaceholder: 'Пошук за назвою або артикулом',
      filters: 'Фільтри',
      resetAll: 'Скинути все',
      category: 'Категорія',
      topic: 'Тема',
      priceUah: 'Ціна (грн)',
      priceFrom: 'Від',
      priceTo: 'До',
      sort: 'Сортування',
      sortDefault: 'За замовчуванням',
      sortPriceAsc: 'Від дешевих до дорогих',
      sortPriceDesc: 'Від дорогих до дешевих',
      foundItems: 'Знайдено товарів',
      catWorkbook: 'Воркбук',
      catFlashcards: 'Картки',
      catMerch: 'Мерч',
    },
    wishlist: {
      title: 'Обрані товари',
      empty: 'Список обраного порожній',
      emptyHint: 'Натисніть серце на товарі в магазині, щоб додати його сюди',
      goToShop: 'Перейти до магазину',
      addToCart: 'Додати в кошик',
      currency: 'грн',
    },
    childOffers: {
      determineLevel: 'Спершу визнач свій рівень',
      determineLevelDesc: 'Пройди тест на рівень англійської, щоб побачити персональні пропозиції',
      offersForYou: 'Пропозиції для тебе',
      pickedForLevel: 'Спеціально підібрані для твого рівня {{level}}',
      groupClasses: 'Групові заняття',
      groupsDesc: 'Вчися разом з однолітками',
      students: 'учнів',
      start: 'Старт',
      individualLessons: 'Індивідуальні уроки',
      individualDesc: 'Заняття один на один з вчителем',
      individualAsk: 'Хочеш вчитися індивідуально? Попроси батьків записати тебе на урок!',
      learnMore: 'Дізнатися більше',
      learningMaterials: 'Навчальні матеріали',
      materialsDesc: 'Книжки та картки для навчання',
      onlineCourses: 'Онлайн курси',
      coursesDesc: 'Вчися у своєму темпі',
      free: 'Безкоштовно',
      noOffersYet: 'Наразі немає спеціальних пропозицій для твого рівня',
      currency: 'грн',
    },
    specialOffers: {
      title: 'Спеціальні пропозиції',
      learnMore: 'Дізнатися більше',
    },
    childTopUp: {
      title: 'Поповнити баланс',
      forChild: 'дитини',
      amount: 'Сума поповнення',
      customAmount: 'Або введіть суму',
      pay: 'Оплатити',
      requisites: 'Реквізити для оплати',
      cardNumber: 'Номер картки',
      cardholder: 'Отримувач',
      bank: 'Банк',
      requisitesEmpty: 'Реквізити ще не налаштовані адміністратором',
      amountLbl: 'Сума',
      uploadReceipt: 'Завантажте квитанцію або скріншот оплати',
      fileHint: 'PNG, JPG до 5MB',
      clickToUpload: 'Натисніть для завантаження',
      delete: 'Видалити',
      back: 'Назад',
      uploading: 'Завантаження...',
      paidBtn: 'Я оплатив(ла)',
      approved: 'Оплату підтверджено!',
      approvedMsg: 'Оплату підтверджено! Баланс дитини оновлено.',
      rejected: 'Оплату відхилено',
      rejectedMsg: 'Оплату відхилено.',
      pending: 'Оплата перевіряється',
      pendingMsg: 'Кошти будуть зараховані на баланс дитини після перевірки адміністратором.',
      loading: 'Завантаження...',
      tryAgain: 'Спробувати ще',
      close: 'Закрити',
      autoUpdate: 'Статус оновлюється автоматично',
      closeWindowTitle: 'Закрити вікно?',
      closeWindowMsg: 'Ви ще не завершили оплату. Якщо закриєте вікно, прогрес буде втрачено. Ви впевнені?',
      continue: 'Продовжити',
      fileTooLarge: 'Файл занадто великий. Максимальний розмір: 5MB',
      parentNotFound: 'Не вдалося визначити батьківський акаунт. Будь ласка, перезавантажте сторінку.',
      uploadError: 'Помилка завантаження файлу',
      requestError: 'Помилка створення запиту',
      connectionError: 'Помилка підключення до сервера',
      error: 'Помилка',
      currency: 'грн',
    },
    topUp: {
      title: 'Поповнити баланс',
      amountLabel: 'Сума поповнення',
      customAmount: 'Або введіть суму',
      payBtn: 'Оплатити',
      requisites: 'Реквізити для оплати',
      cardNumber: 'Номер картки:',
      cardholder: 'Отримувач:',
      bank: 'Банк:',
      requisitesEmpty: 'Реквізити ще не налаштовані адміністратором',
      amountLine: 'Сума: {{amount}} грн',
      uploadReceipt: 'Завантажте квитанцію або скріншот оплати',
      fileHint: 'PNG, JPG до 5MB',
      clickToUpload: 'Натисніть для завантаження',
      delete: 'Видалити',
      back: 'Назад',
      uploading: 'Завантаження...',
      paidBtn: 'Я оплатив(ла)',
      approvedTitle: 'Оплату підтверджено!',
      rejectedTitle: 'Оплату відхилено',
      pendingTitle: 'Оплата перевіряється',
      approvedMsg: 'Оплату підтверджено! Баланс оновлено.',
      rejectedDefault: 'Оплату відхилено.',
      pendingMsg: 'Кошти будуть зараховані на баланс після перевірки адміністратором.',
      loading: 'Завантаження...',
      amountInfo: 'Сума:',
      refreshBalance: 'Оновити баланс',
      refreshing: 'Оновлення...',
      tryAgain: 'Спробувати ще',
      close: 'Закрити',
      autoUpdate: 'Статус оновлюється автоматично',
      closeWindowTitle: 'Закрити вікно?',
      closeWindowMsg: 'Ви ще не завершили оплату. Якщо закриєте вікно, прогрес буде втрачено. Ви впевнені?',
      continueBtn: 'Продовжити',
      fileTooLarge: 'Файл занадто великий. Максимальний розмір: 5MB',
      uploadError: 'Помилка завантаження файлу',
      errorTitle: 'Помилка',
      currency: 'грн',
    },
    clubs: {
      freeBookingTitle: 'Безкоштовний запис на клуб!',
      discountTitle: 'Знижка {{discount}}% на клуби!',
      offerSubtitle: 'Оберіть будь-який клуб зі знижкою',
      allClubs: 'Всі клуби',
      allLevels: 'Всі рівні',
      levelStarter: 'A0 (Starter)',
      levelBeginner: 'A1 (Beginner)',
      levelElementary: 'A2 (Elementary)',
      levelIntermediate: 'B1 (Intermediate)',
      levelUpper: 'B2 (Upper-Intermediate)',
      levelAdvanced: 'C1 (Advanced)',
      clubsHistory: 'Історія клубів',
      historyRecords: '{{count}} записів',
      filterAll: 'Все',
      filterBookings: 'Бронювання',
      filterSubscriptions: 'Абонементи',
      filterCancelled: 'Скасовані',
      noRecordsInCategory: 'Немає записів у цій категорії',
      subscriptionPurchased: 'Придбано абонемент',
      subscriptionExhausted: 'Абонемент вичерпано',
      sessionsUsedAll: 'Використано всі заняття',
      sessions4: '4 заняття',
      sessions8: '8 занять',
      statusActive: 'Активний',
      statusExpired: 'Закінчився',
      statusExhausted: 'Використано',
      club: 'Клуб',
      subscription: 'Абонемент',
      upcomingClubs: 'Майбутні клуби',
      noScheduledClubs: 'Немає запланованих клубних занять',
      spotsLeft: '{{spots}} вільних місць',
      noSpotsLeft: 'Немає вільних місць',
      audienceChild: 'Діти',
      audienceTeen: 'Підлітки',
      audienceAdult: 'Дорослі',
      free: 'Безкоштовно',
      cancelBooking: 'Скасувати',
      inReserve: 'В резерві',
      cancelReserve: 'Скасувати резерв',
      book: 'Забронювати',
      reserve: 'Резерв',
      moreAboutClub: 'Детальніше про клуб',
      subscriptionTitle: 'Абонемент',
      subscriptionSubtitle: 'Вигідніше відвідувати клуби',
      buySubscription: 'Придбати абонемент',
      allClubsType: 'Всі клуби',
      remainingSessions: 'Залишилось {{count}} {{word}}',
      sessionOne: 'заняття',
      sessionFew: 'заняття',
      sessionMany: 'занять',
      validUntil: 'Дійсний до: {{date}}',
      pricesTitle: 'Ціни на клуби',
      singleSession: 'Разове заняття',
      perSession: '{{price}} грн/заняття',
      subscription30days: 'Абонемент дійсний 30 днів з моменту придбання',
      warning: 'Увага!',
      cancelBookingQuestion: 'Скасувати бронювання?',
      cancelPromoWarning: 'Це заняття було заброньоване за промокодом. Якщо скасувати — промокод згорить і не повернеться. Точно скасувати "{{name}}"?',
      cancelPenaltyWarning: 'До заняття залишилось менше 4 годин. При скасуванні кошти не повертаються.',
      cancelConfirmQuestion: 'Ви дійсно хочете скасувати бронювання "{{name}}"?',
      no: 'Ні',
      yesCancel: 'Так, скасувати',
      confirm: 'Підтвердити',
      cancelling: 'Скасовуємо...',
      bookingConfirmation: 'Підтвердження бронювання',
      alreadyBooked: 'Ви вже забронювали цей клуб',
      notEnoughFunds: 'Недостатньо коштів на балансі',
      clubLbl: 'Клуб:',
      dateLbl: 'Дата:',
      timeLbl: 'Час:',
      levelLbl: 'Рівень:',
      priceLbl: 'Вартість:',
      freePromo: 'Безкоштовно (промокод)',
      bySubscription: 'За абонементом',
      availableFreeClubs: '🎁 Доступно безкоштовних клубних занять:',
      havePromoCode: 'Є промокод?',
      promoPlaceholder: 'BDAY-XXXXXXXX',
      activate: 'Активувати',
      linkInSchedule: 'Посилання на заняття з\'явиться у розкладі',
      readAndAccept: 'Я прочитав(-ла) та приймаю',
      termsOfService: 'Умови надання послуг',
      termsBookingSuffix: ', зокрема правила оплати, скасування та повернення коштів за клубні заняття.',
      cancel: 'Скасувати',
      booking: 'Бронюємо...',
      buySubTitle: 'Придбати абонемент',
      sessionsWord: 'занять',
      buyBtn: 'Придбати',
      subscription30line: 'Абонемент дійсний 30 днів з моменту придбання',
      reserveSpot: 'Резервування місця',
      allSpotsTaken: 'Всі місця на цей клуб зайняті. Ви можете зарезервувати місце — якщо хтось скасує бронювання або адмін збільшить кількість місць, вас буде автоматично заброньовано та повідомлено.',
      freezeFunds: 'Заморозка коштів:',
      oneSessionFromSub: '1 заняття з абонемента',
      frozenReturnIfNotFree: 'Кошти будуть заморожені та повернуться, якщо місце не звільниться',
      termsReserveSuffix: ', зокрема правила резервування, автоматичного бронювання та повернення заморожених коштів (розділ 5).',
      reserving: 'Резервуємо...',
      reserveBtn: 'Зарезервувати',
      cancelReserveQuestion: 'Скасувати резерв?',
      cancelReserveConfirm: 'Ви дійсно хочете скасувати резерв на "{{name}}"? Заморожені кошти будуть повернуті.',
      detailsLevel: 'Рівень: {{level}}',
      descriptionLbl: 'Опис',
      noDescription: 'Опис відсутній',
      teacherLbl: 'Викладач',
      dateAndTime: 'Дата та час',
      duration: 'Тривалість',
      minutes: 'хв',
      spots: 'Місця',
      spotsOfTotal: '{{spots}} вільних місць з {{total}}',
      allTaken: 'Всі місця зайняті',
      price: 'Вартість',
      additionalInfo: 'Додаткова інформація',
      close: 'Закрити',
      promoNotForClub: 'Цей промокод не для клубних занять — активуйте його в розділі «Розклад».',
      promoActivated: 'Промокод активовано: +{{count}} безкоштовне заняття клубу',
      networkErrorRetry: 'Помилка мережі. Спробуй ще раз.',
      couldNotActivate: 'Не вдалося активувати',
      bookingErrorGeneric: 'Помилка бронювання',
      statusBooked: 'Заброньовано',
      statusAttended: 'Відвідано',
      statusCancelledOnTime: 'Скасовано вчасно',
      statusCancelledLate: 'Скасовано невчасно',
      statusNoShow: 'Не з\'явився',
    },
    courses: {
      lessonsCount: '{{count}} уроків',
      lessons: 'уроків',
      purchased: 'Придбано',
      continue: 'Продовжити',
      free: 'Безкоштовно',
      buy: 'Придбати',
      enroll: 'Записатися',
      backToCourses: 'Назад до курсів',
      blocks: 'Блоків',
      level: 'Рівень',
      initialTest: 'Початковий тест',
      testResult: 'Результат: {{score}} з {{total}} балів',
      pointsOfTotal: '{{score}} з {{total}} балів',
      takeTestBeforeStart: 'Пройдіть тест перед початком навчання',
      takeTest: 'Пройти тест',
      startLearning: 'Розпочати навчання',
      buyCourse: 'Придбати курс',
      courseProgram: 'Програма курсу',
      lessonsShort: '{{count}} уроків',
      stepsCount: '{{count}} кроків',
      programNotFormed: 'Програма курсу ще не сформована',
      purchaseConfirmation: 'Підтвердження покупки',
      coursePrice: 'Вартість курсу:',
      yourBalance: 'Ваш баланс:',
      notEnoughTopUpBy: 'Недостатньо коштів. Поповніть баланс на {{amount}} грн.',
      cancel: 'Скасувати',
      confirmPurchase: 'Підтвердити покупку',
      coursePurchased: 'Курс успішно придбано!',
      canStartLearning: 'Тепер ви можете почати навчання',
      continueBtn: 'Продовжити',
      goToMyCourses: 'Перейти до моїх курсів',
      initialTestIntro: 'Перед проходженням курсу пройдіть тест, щоб зафіксувати початковий результат. Таким чином ми зможемо зрозуміти, на яку частину курсу звернути більше уваги, і надалі зможемо відслідковувати ваш прогрес.',
      questionsCount: '{{count}} питань',
      pointsCount: '{{count}} балів',
      later: 'Пізніше',
      startTest: 'Почати тест',
      taskOf: 'Завдання {{current}} з {{total}}',
      markAnswers: 'Позначте відповіді:',
      skip: 'Пропустити',
      next: 'Наступне',
      finishTest: 'Завершити тест',
      questionOf: 'Питання {{current}} з {{total}}',
      back: 'Назад',
      nextShort: 'Далі',
      testCompleted: 'Тест завершено!',
      yourResult: 'Ваш результат: {{score}} з {{total}} балів',
      startTrainingBtn: 'Розпочати навчання',
      overview: 'Огляд',
      video: 'Відео',
      notes: 'Конспект',
      exercise: 'Вправа',
      videoLoading: 'Завантаження відео...',
      videoNotAdded: 'Відео не додано',
      notesEmpty: 'Конспект порожній',
      exerciseTitle: 'Вправа',
      option: 'Варіант {{n}}',
      enterAnswer: 'Введіть вашу відповідь...',
      correctAnswerLbl: 'Правильна відповідь:',
      leftPart: 'Ліва частина {{n}}',
      rightPart: 'Права частина {{n}}',
      previousResult: 'Ваш попередній результат',
      result: 'Результат:',
      tryImprove: 'Ви можете спробувати ще раз, щоб покращити результат',
      tryAgain: 'Спробувати ще раз',
      checkAnswer: 'Перевірити відповідь',
      previousStep: 'Попередній крок',
      nextStep: 'Наступний крок',
      initialTestSubtitle: 'Пройдіть тест, щоб визначити ваш рівень і розблокувати навчання',
      passTest: 'Пройти тест',
      resultShort: 'Ваш результат',
      courseProgress: 'Прогрес курсу',
      passedOf: 'Пройдено {{done}} з {{total}} уроків',
      completedLbl: 'Завершено',
      completedLessons: 'Завершено уроків',
      remainingLessons: 'Залишилось пройти',
      pickLessonHint: 'Оберіть урок зліва, щоб продовжити навчання',
      pickLessonFromList: 'Виберіть урок зі списку',
      availableCourses: 'Доступні курси',
      myCourses: 'Мої курси',
      balance: 'Баланс:',
      searchCourses: 'Пошук курсів...',
      levelA1: 'A1 - Початковий',
      levelA2: 'A2 - Елементарний',
      levelB1: 'B1 - Середній',
      levelB2: 'B2 - Вище середнього',
      levelC1: 'C1 - Просунутий',
      levelC2: 'C2 - Професійний',
      allLevels: 'Всі рівні',
      noCoursesForQuery: 'Курсів за вашим запитом не знайдено',
      noAvailableCourses: 'Наразі немає доступних курсів',
      noPurchasedYet: 'У вас ще немає придбаних курсів',
      viewAvailable: 'Переглянути доступні курси',
    },
    childMgmt: {
      insufficientChildFunds: 'Недостатньо коштів на балансі дитини. Необхідно: {{amount}} грн, баланс: {{balance}} грн. Поповніть баланс.',
      paymentError: 'Помилка при оплаті',
      connectionRetry: 'Помилка з\'єднання. Спробуйте пізніше.',
      pickTeacherAndTime: 'Оберіть викладача, дні та час занять',
      successEnrolled: 'Успішно записано! Оплата буде списуватись автоматично по 450 грн за кожне заняття.',
      enrollError: 'Помилка при записуванні',
      enrollRetry: 'Помилка при записуванні. Спробуйте пізніше.',
      pickGroup: 'Оберіть групу',
      groupLesson: 'Групові заняття "{{name}}"',
      groupJoinError: 'Помилка запису в групу',
      clubLabel: 'Клуб "{{name}}"',
      clubBookError: 'Помилка бронювання клубу',
      nameEmpty: 'Ім\'я не може бути порожнім',
      ageInvalid: 'Вкажіть коректний вік',
      childDataUpdated: 'Дані дитини оновлено',
      saveError: 'Помилка при збереженні даних',
      enterParentPassword: 'Введіть ваш пароль',
      enterNewPassword: 'Введіть новий пароль',
      passwordTooShort: 'Пароль має бути не менше 4 символів',
      passwordsDontMatch: 'Паролі не співпадають',
      passwordChangeError: 'Помилка при зміні пароля',
      coursePurchase: 'Курс "{{name}}"',
      yearsOldOf: '{{age}} років',
      levelLbl: 'Рівень: {{level}}',
      testProgress: 'Тест: {{done}}/7',
      testNotDone: 'Тест не пройдено',
      topUpChildBalance: 'Поповнити баланс дитини',
      tabProgress: 'Прогрес',
      tabLearning: 'Навчання',
      tabOffers: 'Пропозиції',
      tabBalance: 'Баланс',
      tabPermissions: 'Дозволи',
      tabSettings: 'Налаштування',
      englishLevel: 'Рівень англійської',
      passedOfTotal: '(пройдено {{done}} з 7)',
      testNotPassedYet: 'Тест на визначення рівня ще не пройдено',
      individualLessonsTitle: 'Індивідуальні заняття',
      viewData: 'Переглянути дані',
      enrollWithTeacher: 'Записати на заняття з викладачем',
      groupLessonsTitle: 'Групові заняття',
      enrollInGroup: 'Записати до навчальної групи',
      availableCourses: 'Доступні курси',
      loadingCourses: 'Завантаження курсів...',
      noCoursesAvailable: 'Немає доступних курсів',
      coursesComingSoon: 'Незабаром тут з\'являться нові курси',
      lessonsCountShort: '{{count}} уроків',
      enrolled: 'Записано',
      processing: 'Обробка...',
      buy: 'Придбати',
      free: 'Безкоштовно',
      teacherLbl: 'Викладач',
      scheduleLbl: 'Розклад:',
      pricePerLesson: 'Вартість: {{price}} грн за заняття',
      enrollToIndividual: 'Записати на індивідуальні заняття',
      pickDays: 'Оберіть дні занять',
      timeFor: 'Час для {{day}}',
      pickTeacher: 'Оберіть викладача',
      searchingTeachers: 'Пошук викладачів...',
      noTeachersAvailable: 'На жаль, немає викладачів з вільними слотами в обраний час',
      tryDifferentTime: 'Спробуйте обрати інший час або дні занять',
      oneLesson: 'Одне заняття:',
      priceAutoDeducted: 'Оплата автоматично списується за кожне заняття',
      enroll: 'Записати',
      levelStudents: 'Рівень {{level}} • {{count}} учнів',
      availableGroups: 'Доступні групи (рівень {{level}})',
      loadingGroups: 'Завантаження груп...',
      noGroupsForLevel: 'Немає доступних груп для рівня {{level}}',
      tryIndividual: 'Спробуйте записатись на індивідуальні заняття',
      scheduleTbd: 'Розклад уточнюється',
      studentsCount: '{{current}}/{{max}} учнів',
      pricePerMonth: '{{price}} грн/міс',
      enrollToGroupPrice: 'Записати до групи за {{price}} грн',
      clubs: 'Клуби',
      allClubs: 'Всі клуби',
      noScheduledClubs: 'Немає запланованих клубних занять',
      spotsLbl: '{{spots}} місць',
      specialOffers: 'Спеціальні пропозиції',
      personalizedForLevel: 'Персоналізовані рекомендації для рівня {{level}}',
      takeLevelTestFirst: 'Спершу пройдіть тест на рівень',
      seePersonalized: 'Щоб побачити персональні пропозиції',
      matchingGroups: 'Відповідні групи за рівнем',
      groupCountLine: '{{current}}/{{max}} учнів',
      individualLessons: 'Індивідуальні уроки',
      personalApproach: 'Персональний підхід до навчання',
      individualEffective: 'Індивідуальні заняття з викладачем — найефективніший спосіб вивчити англійську!',
      pricePerLessonLine: '{{price}} грн/урок',
      promotions: 'Акції та знижки',
      specialProposals: 'Спеціальні пропозиції',
      until: 'До {{date}}',
      recommendedProducts: 'Рекомендовані товари',
      materialsForLevel: 'Навчальні матеріали для рівня {{level}}',
      onlineCourses: 'Онлайн курси',
      selfStudy: 'Самостійне навчання',
      noOffersForLevel: 'Наразі немає спеціальних пропозицій для цього рівня',
      currentBalance: 'Поточний баланс',
      currentStars: 'Зірочки',
      topUp: 'Поповнити',
      transactionHistory: 'Історія транзакцій',
      noTransactions: 'Немає транзакцій',
      pending: 'Очікує',
      rejected: 'Відхилено',
      childData: 'Дані дитини',
      nameLbl: 'Ім\'я',
      enterName: 'Введіть ім\'я',
      ageLbl: 'Вік',
      enterAge: 'Введіть вік',
      nicknameLbl: 'Нікнейм',
      nicknameCannotChange: 'Нікнейм не можна змінити',
      birthdayLbl: 'День народження',
      saving: 'Збереження...',
      saveData: 'Зберегти дані',
      passwordLbl: 'Пароль',
      changePassword: 'Змінити пароль',
      parentPasswordLbl: 'Ваш пароль (батька)',
      enterYourPassword: 'Введіть ваш пароль',
      newChildPassword: 'Новий пароль дитини',
      enterNewPasswordPh: 'Введіть новий пароль',
      confirmNewPassword: 'Підтвердіть новий пароль',
      repeatPassword: 'Повторіть пароль',
      cancel: 'Скасувати',
      save: 'Зберегти',
      passwordChanged: 'Пароль змінено',
      passwordSavedFor: 'Новий пароль для {{name}} успішно збережено',
      close: 'Закрити',
      bookingConfirmation: 'Підтвердження бронювання',
      clubLbl: 'Клуб:',
      dateLbl: 'Дата:',
      forLbl: 'Для:',
      priceLbl: 'Вартість:',
      bookBtn: 'Забронювати',
      successExclaim: 'Успішно!',
      atTime: 'о {{time}}',
    },
    learningSettings: {
      pickProgram: 'Оберіть програму',
      multipleProgramsHint: 'У вас декілька програм навчання. Оберіть, для якої програми ви хочете змінити розклад.',
      programFallback: 'Програма',
      groupLearning: 'Групове навчання • {{teacher}}',
      individualLearning: 'Індивідуальне • {{teacher}}',
      teacherFallback: 'Викладач',
      fixedSchedule: 'Фіксований розклад',
      groupLearningTitle: 'Групове навчання',
      groupScheduleFixed: 'Розклад групових занять фіксований і не може бути змінений індивідуально.',
      groupCurrentSchedule: 'Поточний розклад групи:',
      dayAt: '{{day}} о {{time}}',
      groupContactAdmin: 'Якщо розклад групи вам не підходить, зверніться до адміністратора для переведення в іншу групу з іншим розкладом.',
      understood: 'Зрозуміло',
      takeVacation: 'Взяти канікули',
      pauseLessonsPeriod: 'Призупинити уроки на певний період',
      changeLearningTime: 'Змінити час навчання',
      pickAnotherTime: 'Обрати інший час для уроків',
      changeTeacher: 'Змінити вчителя',
      pickAnotherTeacher: 'Обрати іншого викладача',
      freezeLearning: 'Заморозити навчання',
      pauseIndefinite: 'Призупинити на невизначений термін',
      currentSettings: 'Поточні налаштування:',
      teacherLbl: 'Вчитель:',
      scheduleLbl: 'Розклад:',
      progressLbl: 'Прогрес:',
      progressOf: '{{done}} з {{total}} уроків',
      vacationOncePerMonth: 'Канікули можна брати лише раз на місяць',
      nextVacationDate: 'Наступні канікули можна оформити з {{date}}',
      vacationOverlap: 'Вже існують канікули, що перетинаються з цим періодом',
      whatIsVacation: 'Що таке канікули?',
      vacationExplanation: 'Під час канікул уроки не проводяться. Після закінчення канікул навчання продовжиться за тим самим розкладом, з тим самим вчителем і з того самого місця програми. Канікули можна оформити на термін не більше 2 тижнів.',
      vacationStart: 'Дата початку канікул',
      vacationEnd: 'Дата закінчення канікул',
      vacationTooLong: 'Термін канікул перевищує 2 тижні. Будь ласка, оберіть коротший період.',
      processing: 'Оформлення...',
      createVacation: 'Оформити канікули',
      currentVacations: 'Поточні канікули:',
      vacationOngoing: 'Канікули тривають. Скасувати неможливо.',
      scheduledVacations: 'Заплановані канікули:',
      cancel: 'Скасувати',
      changingSchedule: 'Зміна розкладу',
      chooseDaysHint: 'Оберіть від 1 до 7 днів на тиждень та час для кожного дня. Всі майбутні уроки будуть перегенеровані відповідно до нового розкладу.',
      changesUsed: 'Використано змін цього місяця: {{used}} з {{max}}',
      limitReached: 'Ви вичерпали ліміт змін на цей місяць',
      programLbl: 'Програма:',
      teacherLine: 'Вчитель: {{name}}',
      currentTeacherLbl: 'Поточний вчитель:',
      pickDaysHint: 'Оберіть дні занять (1-7):',
      teacherUnavailable: 'Викладач недоступний у цей день',
      timeForDay: 'Час для {{day}}:',
      noFreeSlots: 'Немає вільних слотів',
      lessonsRegenerated: '{{count}} уроків буде перегенеровано відповідно до нового розкладу.',
      changingScheduleBtn: 'Зміна розкладу...',
      saveNewSchedule: 'Зберегти новий розклад',
      noSlotsAvail: 'Немає доступних слотів',
      changeTeacherLink: 'Змінити вчителя',
      changeTeacherTitle: 'Зміна вчителя',
      changeTeacherHint: 'Оберіть нового вчителя. Вчителі, які вільні в інший час, позначені окремо - при їх виборі потрібно буде також змінити час.',
      availableTeachers: 'Доступні вчителі:',
      changingTeacher: 'Зміна вчителя...',
      changeTeacherBtn: 'Змінити вчителя',
      important: 'Важливо!',
      freezeExplanation: 'При заморозці навчання всі заплановані уроки будуть призупинені. Після повернення до навчання:',
      freezeReasonProgram: 'Ви продовжите з того самого місця програми',
      freezeReasonTeacher: 'Може змінитися вчитель',
      freezeReasonTime: 'Може змінитися час та дні навчання',
      freezeReasonPrice: 'Ціна може змінитися відповідно до актуальних тарифів',
      yourCurrentProgress: 'Ваш поточний прогрес:',
      stopAtLesson: 'Зупинитесь на уроці №{{lesson}}',
      understandFreeze: 'Я розумію, що після розморозки навчання може змінитися вчитель, час та ціна',
      freezing: 'Заморожування...',
      freezeBtn: 'Заморозити навчання',
      vacationSetUp: 'Канікули оформлено! {{count}} уроків буде пропущено.',
      vacationCancelled: 'Канікули скасовано! {{count}} уроків відновлено.',
      studyFrozen: 'Навчання заморожено. {{count}} уроків призупинено.',
      scheduleChanged: 'Розклад змінено! {{count}} уроків заплановано.',
      contactAdminForTeacher: 'Для зміни вчителя зверніться до адміністратора',
      requestSentToParent: 'Запит надіслано батьку. Очікуй підтвердження.',
      configureLearning: 'Налаштувати навчання',
    },
    adult: {
      teacherFallback: 'Викладач',
      clubTeacherFallback: 'Вчитель клубу',
      lessonTypeIndividual: 'Індивідуальний урок',
      lessonTypeGroup: 'Груповий урок',
      chatTimeNow: 'Зараз',
      navProfile: 'Профіль',
      navSchedule: 'Розклад',
      navClubs: 'Клуби',
      navChat: 'Чат',
      navAiChat: 'Практика з Кеном',
      navAiChatShort: 'Кен',
      readerTitle: 'Reader — застосунок для читання',
      shopTitle: 'Магазин',
      lightTheme: 'Світла тема',
      darkTheme: 'Темна тема',
      loading: 'Завантаження...',
      balanceHistory: 'Історія балансу',
      transactionAt: '{{date}} о {{time}}',
      topupLabel: 'Поповнення',
      lessonPayment: 'Оплата уроку',
      currency: 'грн',
      currentBalance: 'Поточний баланс:',
      topupDescription: 'Поповнення балансу',
      lessonWithTeacher: 'Урок з {{teacher}}',
      homeworkFallback: 'Домашнє завдання',
      homeworkTitle: 'Домашні завдання',
      tabNew: 'Нові ({{count}})',
      tabOverdue: 'Прострочені ({{count}})',
      tabCompleted: 'Виконані ({{count}})',
      exercisesCount: '{{count}} вправ',
      pointsCount: '{{count}} балів',
      deadline: 'Дедлайн: {{date}}',
      deadlineWas: 'Дедлайн був: {{date}}',
      doHomework: 'Виконати',
      doHomeworkLate: 'Виконати (буде здано невчасно)',
      overdueBadge: 'Прострочено',
      submittedLateBadge: 'Здано невчасно',
      scoreLabel: 'Результат: {{score}}',
      completedOn: 'Виконано: {{date}}',
      viewHomework: 'Переглянути',
      emptyPending: 'Немає активних домашніх завдань',
      emptyOverdue: 'Немає прострочених завдань',
      emptyCompleted: 'Немає виконаних домашніх завдань',
    },
  },
  en: {
    dashboard: {
      lingvishSpace: 'LINGVISH SPACE',
      navProfile: 'Profile',
      navSchedule: 'Schedule',
      navClubs: 'Clubs',
      navChat: 'Chat',
      navAiChat: 'Practice with Ken',
      navAiChatShort: 'Ken',
      exit: 'Exit',
      childAccountNotFound: 'Child account not found',
      backButton: 'Go back',
      downloadReport: 'Download report',
      pdfLearningReport: 'PDF learning report',
      linkAccount: 'Link account',
      linkAccountDesc: 'Invite a parent or another account',
      reportModalTitle: 'Download report',
      reportModalIntro: 'Pick a month to generate the report. The report will include information about lessons, homework, grades and achievements.',
      month: 'Month',
      reportLanguage: 'Report language',
      ukrainian: 'Ukrainian',
      english: 'English',
      reportContains: 'The report will include:',
      contentLessons: 'Number of lessons in the month',
      contentHomework: 'Completed and missed homework',
      contentReview: 'Review scores',
      contentCancelled: 'Cancelled lessons',
      generating: 'Generating...',
      download: 'Download',
      successTitle: 'Success',
      reportDownloaded: 'Report downloaded!',
      errorTitle: 'Error',
      reportFailed: 'Could not generate the report',
      passwordChangeError: 'Password change error',
      passwordChanged: 'Password successfully changed',
      profileDeleted: 'Profile successfully deleted',
      connectionError: 'Connection error',
      profileDeleteError: 'Profile deletion error',
      completeRegistrationTitle: 'Finish setting up your account',
      completeRegistrationSubtitle: 'Tell us a bit about yourself and take the level test to unlock personalised learning.',
      completeRegistrationCta: 'Complete registration',
    },
    profileTab: {
      happyBirthday: 'Happy Birthday, {{name}}! 🎂',
      festiveModeSubtitle: 'Festive profile mode for 24 hours',
      myStars: 'My stars',
      topUp: 'Top up',
      starHistory: 'Star history',
      englishLevel: 'English level',
      continueTest: 'Continue test ({{done}}/{{total}})',
      completeTestPersonalized: 'Complete the test for personalised learning',
      takeTestForLevel: 'Take the test to determine your level',
      completeTest: 'Complete test',
      takeTest: 'Take test',
      family: 'Family',
      linkAccount: 'Link account',
      linkAccountEmpty: 'Link your child\'s account to see their progress, or link a parent account to manage learning',
      yearsOld: 'years old',
      testPassed: 'Test passed',
      testNotPassed: 'Test not taken',
      currency: 'UAH',
      manage: 'Manage',
      enterProfile: 'Enter',
      enterChildFailed: 'Failed to enter the child profile',
      adultAccount: 'Adult account',
      addChildTitle: 'Add a child',
      childFullName: 'Child full name',
      childFullNamePlaceholder: 'e.g. Sofia Koval',
      loginNickname: 'Login nickname',
      nicknamePlaceholder: 'e.g. sofia_kid',
      nicknameHint: 'Latin letters, digits and _ (the child will log in with this nickname)',
      email: 'Email',
      emailPlaceholder: 'e.g. sofia@example.com',
      emailHint: 'The email is linked to the child account (for password recovery)',
      age: 'Age',
      agePlaceholder: 'From 3 to 17 years',
      password: 'Password',
      passwordPlaceholder: 'e.g. kotik7',
      passwordHint: '. The child will use this password to log in.',
      cancel: 'Cancel',
      add: 'Add',
      loadingHistory: 'Loading…',
      noHistoryYet: 'No history yet',
      reasonLessonStars: 'Lesson reward',
      reasonPurchaseStars: 'Star purchase',
      reasonKenSkin: 'Ken skin purchase',
      reasonAdminGrant: 'Admin grant',
      reasonOperation: 'Operation',
      close: 'Close',
      deleteProfileTitle: 'Delete profile?',
      deleteProfileMsg: 'Are you sure you want to delete your profile? This action cannot be undone.',
      delete: 'Delete',
      convertToAdultTitle: 'Convert to adult account?',
      convertToAdultMsg: 'Convert {{name}} to an adult account? This action cannot be undone.',
      convert: 'Convert',
      deleteChildTitle: 'Delete child account?',
      deleteChildMsg: 'Delete the child account for {{name}}? All data will be lost.',
      needVerifiedEmail: 'Verified email required',
      convertEmailWarning: 'Before {{name}} becomes an independent account, they need to log in to their profile and {{action}}. Without this, they will not be able to sign in and recover their password.',
      addEmail: 'add an email and verify it',
      verifyEmail: 'verify their email',
      childCreateError: 'Error creating child account',
      nicknameTaken: 'This nickname is already taken. Please choose another one.',
      emailTaken: 'This email is already taken. Please choose another one.',
      connectionTryLater: 'Connection error. Please try again later.',
      convertAccountError: 'Error converting account',
      deleteAccountError: 'Error deleting account',
    },
    scheduleTab: {
      schedule: 'Schedule',
      homework: 'Homework',
      homeworkShort: 'HW',
      repetition: 'Repetition',
      moduleTests: 'Module tests',
      testsShort: 'Tests',
      scheduleTitle: 'Lesson schedule',
      vacation: 'Vacation!',
      noLessonsThisDay: 'No lessons on this day',
      firstLessonAwaits: 'Your first lesson awaits!',
      pickTeacherFormat: 'Pick a convenient time, teacher and learning format',
      enrollInLesson: 'Enroll in a lesson',
      individually: 'Individually',
      group: 'Group',
      noPlannedLessons: 'No lessons planned for this day',
      vacationTooltip: 'Vacation',
      vacationClubTooltip: 'Vacation (club session available)',
      movieClub: 'Movie Club',
      bookClub: 'Book Club',
      grammarClub: 'Grammar Club',
      speakingClub: 'Speaking Club',
      individualLesson: 'Individual lesson',
      groupLesson: 'Group lesson',
      paidByPromo: 'Paid with promo code',
      paidByReschedule: 'Paid on reschedule',
      paidBySeries: 'First lesson of series — paid on start',
      paidByCompensation: 'Paid as compensation for teacher force majeure',
      paidInAdvance: 'Prepaid',
      paid: 'Paid',
      clubSession: 'Club session',
      awaitingPayment: 'Awaiting payment',
      topUpDeadline: 'Top up your balance ({{price}} UAH) by {{deadline}}',
      topUpBalance: 'Top up balance',
      join: 'Join',
      reschedule: 'Reschedule',
      cancel: 'Cancel',
      cancelLessonPenalty: 'Less than 4 hours to the lesson. On cancellation the money will not be refunded. Cancel anyway?',
      cancelLessonConfirm: 'Are you sure you want to cancel the lesson?',
      cancelLessonQuotaExceeded: 'You have used all free cancellations this month ({{max}} of {{max}}). This cancellation will be charged — the lesson fee will not be refunded. Cancel anyway?',
      freeCancellationsLeft: 'Free cancellations left this month: {{remaining}} of {{max}}',
      no: 'No',
      confirm: 'Confirm',
      yesCancel: 'Yes, cancel',
      cancelledByStudent: 'Cancelled by student',
      requestSentToParent: 'Request sent to your parent. Wait for approval.',
      configureLearning: 'Configure learning',
      lessonHistory: 'Lesson history',
      groupRecordingsTitle: 'Group lesson recordings',
      groupRecordingsMissed: 'Missed',
      groupRecordingsWatch: 'Watch',
      groupRecordingsPart: 'Part {{n}}',
      rules: 'Rules',
      enrollInLessonBtn: 'Enroll in a class',
      homeworkTitle: 'Homework',
      tabNew: 'New',
      tabOverdue: 'Overdue',
      tabCompleted: 'Completed',
      exercisesLbl: 'exercises',
      pointsLbl: 'points',
      deadline: 'Deadline',
      deadlineWas: 'Deadline was',
      complete: 'Complete',
      completeLate: 'Complete (will be submitted late)',
      noActiveHw: 'No active homework',
      noOverdueHw: 'No overdue homework',
      noCompletedHw: 'No completed homework',
      overdueTag: 'Overdue',
      submittedLate: 'Submitted late',
      result: 'Result',
      completedOn: 'Completed',
      review: 'Review',
      repetitionTitle: 'Repetition',
      passingScore: 'Passing',
      timeLimit: 'Limit',
      questionsCount: 'questions',
      pointsCount: 'points',
      minutesLimit: 'min',
      starting: 'Starting...',
      startTest: 'Start test',
      noModuleTests: 'No module tests available',
      testsAppearWhen: 'Tests will appear when your teacher links them to your program modules',
    },
    repetitionPath: {
      start: 'Start',
      waitNextLesson: 'Wait for the next lesson',
      lessonNotAssigned: 'Lesson not scheduled yet',
      noRepetitionGames: 'No repetition games yet',
      tasksAppearAfterLesson: 'Tasks will appear after your first lesson',
      memory: 'Memory',
      labelledDiagram: 'Labelled Diagram',
      pairOrNoPair: 'Pair or No Pair',
      listenType: 'Listen & Type',
      listenPick: 'Listen & Pick',
      sorting: 'Sorting',
      dictation: 'Dictation',
    },
    childPending: {
      title: 'My requests',
      cancelRequest: 'Cancel request',
      loadFailed: 'Could not load requests',
      cancelFailed: 'Could not cancel',
      parentSaid: 'Parent',
      response: 'responded',
      statusPending: 'Awaiting parent',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusExpired: 'Expired',
    },
    childPermissions: {
      canJoinClub: 'Join clubs',
      canJoinClubHint: 'Single club booking purchase',
      canBuyClubSub: 'Buy club subscription',
      canBuyClubSubHint: 'Package of 4 or 8 sessions',
      canCancelLesson: 'Cancel lessons',
      canRescheduleLesson: 'Reschedule lessons',
      canPayKen: 'Pay for "Practice with Ken"',
      canPayKenHint: 'AI practice subscription',
      canMakePurchases: 'Make purchases in the shop',
      canTakeVacation: 'Take vacations',
      canFreezeStudies: 'Freeze studies',
      loadFailed: 'Could not load permissions',
      saveFailed: 'Could not save',
      enabled: 'on',
      disabled: 'off',
      explanation: 'If the toggle is',
      explanationWhenOn: ', the child performs the action themselves. If it is',
      explanationWhenOff: '— tapping the button creates a request that you will see here and can approve or reject.',
    },
    parentApprovals: {
      title: 'Requests from children',
      filterPending: 'Pending',
      filterApproved: 'Approved',
      filterRejected: 'Rejected',
      filterAll: 'All',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusExpired: 'Expired',
      noRequestsYet: 'No requests yet',
      from: 'From',
      yourComment: 'Your comment',
      commentPlaceholder: 'Comment (optional)',
      approve: 'Approve',
      reject: 'Reject',
      expiredText: 'Request has expired',
      loadFailed: 'Could not load requests',
      processFailed: 'Could not process the request',
    },
    linkAccount: {
      title: 'Link account',
      tabSend: 'Send',
      tabIncoming: 'Incoming',
      tabOutgoing: 'My requests',
      infoText: 'Enter the email of the account you want to link. The change will take effect only after confirmation from the other side.',
      linkType: 'Link type',
      linkAsChild: 'Link as my child',
      linkAsParent: 'Link as my parent',
      unlink: 'Unlink',
      linkAsChildDesc: 'The other account becomes my child (I manage permissions)',
      linkAsParentDesc: 'The other account becomes my parent (manages me)',
      unlinkDesc: 'Remove the existing link',
      otherEmail: 'Other party\'s email',
      messageLabel: 'Message',
      messageOptional: '(optional)',
      sent: 'Request sent. Wait for confirmation.',
      sendRequest: 'Send request',
      noRequests: 'No requests',
      from: 'From',
      to: 'To',
      accept: 'Accept',
      reject: 'Reject',
      cancel: 'Cancel',
      childEmailNotVerified: 'The child account must first log in to their profile, add an email and verify it. Only then can the link be removed.',
      loadFailed: 'Could not load requests',
      sendFailed: 'Could not send request',
      processFailed: 'Could not process request',
      verifyEmailTitle: 'Verify email to unlink',
      verifyEmailDesc: 'Before becoming an independent account, you need to have a verified email so you can sign in and recover your password.',
      statusPending: 'Awaiting confirmation',
      statusAccepted: 'Accepted',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusExpired: 'Expired',
    },
    emailVerify: {
      title: 'Email verification',
      email: 'Email',
      emailHint: 'The email will be saved in your profile. After verification you will be able to unlink from your parent account.',
      codeLabel: 'Verification code',
      resendCode: 'Resend code',
      saveAndSend: 'Save and send code',
      verify: 'Verify',
      codeSent: 'Code sent to your email',
      sendFailed: 'Could not send code',
      invalidEmail: 'Enter a valid email',
      saveFailed: 'Could not save email',
      enter6Digit: 'Enter the 6-digit code',
      invalidCode: 'Invalid code',
    },
    aiChat: {
      trialLeft: 'Free trial: {{days}} {{word}} left.',
      subscriptionMonthly: 'Monthly subscription price — {{price}} UAH.',
      subscribeNow: 'Subscribe now',
      close: 'Close',
      trialEnded: 'Your free trial has ended.',
      subscribe: 'Subscribe',
      videoCallTitle: 'Video call',
      videoCallLocked: 'Subscribe to call Ken',
      videoCallStart: 'Start video call with Ken',
      historyFail: 'Could not load chat history.',
      subscribeFailed: 'Could not subscribe. Please try again.',
      requestSentToParent: 'Request sent to your parent. Wait for approval.',
      tooFast: 'You are writing too fast. Wait a minute.',
      kenBusy: 'Ken is a bit busy. Try again in a minute.',
      cannotGetReply: 'Could not get a reply. Please try again.',
      retryIn: 'Retry in {{seconds}} s.',
      subscribeToWrite: 'Subscribe to write to Ken...',
      waitSeconds: 'Wait {{seconds}} s...',
      writeInEnglish: 'Write to Ken in English...',
      subscribeSubTitle: 'Subscribe',
      practiceWithKen: 'Practice with Ken',
      trialDaysLeft: '{{days}} {{word}} of free trial left',
      trialEndedSubtitle: 'Your free trial has ended',
      priceLine: '{{price}} UAH',
      forDays: '/ {{days}} days',
      benefit1: 'Unlimited messages to Ken',
      benefit2: 'Video calls with Ken',
      benefit3: 'Real-time grammar correction',
      balanceLbl: 'Balance',
      notEnoughAmount: 'Missing {{amount}} UAH. Top up your account in your profile.',
      later: 'Later',
      subscribeBtn: 'Subscribe',
      explanation: 'Explanation',
      dayOne: 'day',
      dayFew: 'days',
      dayMany: 'days',
    },
    kenCall: {
      trialEndedCall: 'Your free trial has ended. Subscribe in chat.',
      micPermission: 'Allow microphone access in your browser and try again.',
      practiceWithKen: 'Practice with Ken',
    },
    prepaidLessons: {
      title: 'Prepaid lessons',
      lessonOne: 'lesson',
      lessonFew: 'lessons',
      lessonMany: 'lessons',
      breakdownPromo: 'Promo code',
      breakdownSeries: 'First lesson of series',
      empty: 'No prepaid lessons at the moment',
      hint: 'Number of upcoming lessons that will not be charged from balance',
      paid: 'prepaid',
    },
    promo: {
      title: 'Promo code',
      placeholder: 'Enter code',
      activate: 'Activate',
      hint: 'Activate a promo code to get a balance bonus or free lessons',
      activateFailed: 'Could not activate promo code',
      clubPromoWrongContext: 'First pick the club session you want to book — the club promo code goes in the booking dialog.',
      connectionError: 'Connection error',
      close: 'Close',
      activated: 'Promo code activated!',
      lessonsCredited: '{{count}} free {{word}} added. The next {{count}} are on us.',
      clubLessonsCredited: '{{count}} free club {{word}} added. The next {{count}} club sessions are on us.',
      balanceCredited: '{{amount}} UAH credited to your balance',
      awesome: 'Awesome',
    },
    starPurchase: {
      title: 'Top up stars',
      yourBalance: 'Your balance',
      currentStars: 'Current stars',
      rate: 'Rate',
      howMany: 'How many stars to buy?',
      toPay: 'To pay',
      notEnoughBalance: 'Not enough funds on balance',
      networkError: 'Network error',
      buyFailed: 'Could not buy stars',
      processing: 'Processing…',
      buy: 'Buy',
    },
    reschedule: {
      title: 'Reschedule lesson',
      currentTime: 'Current time',
      freeLimitUsed: 'Free reschedule limit for this month ({{max}}) is used up. Rescheduling this lesson will be charged double — {{amount}} UAH (for the cancelled lesson and prepayment for the new one). If you don\'t want to pay double, simply cancel the lesson in advance instead of rescheduling.',
      freeLeft: 'Free reschedules this month: {{remaining}} of {{max}}',
      loading: 'Loading…',
      noSlots: 'No free slots at this teacher in the next 14 days.',
      cancel: 'Cancel',
      moving: 'Rescheduling…',
      moveBtn: 'Reschedule',
      insufficient: 'Not enough funds. Need {{need}} UAH, balance {{balance}} UAH. Top up your balance.',
      confirmPaid: 'Confirm paid reschedule',
      confirmPaidText: 'This reschedule will be charged double:',
      forNewLesson: 'For the lesson taken ({{time}})',
      forCancelled: 'For the cancelled lesson ({{time}})',
      total: 'Total',
      confirmPaidNote: 'Free reschedule limit ({{max}}) for this month is used up. If the rescheduled lesson is cancelled ≥ 4 h before start, {{price}} UAH will be transferred to pay for the next lesson in the series (payment for the cancelled slot is not refunded).',
      payAndMove: 'Pay {{amount}} UAH and reschedule',
      requestSentToParent: 'Request sent to your parent. Wait for approval.',
      insufficientBalance: 'Not enough funds. Top up your balance.',
    },
    replacement: {
      title: 'Teacher substitution',
      needDecision: 'Decision needed for rescheduled lessons',
      slotsCount: 'For {{count}} {{word}} your regular teacher is busy. Pick a substitute or skip.',
      slotOne: 'slot',
      slotMany: 'slots',
      choose: 'Choose',
      teacherBusy: 'Your regular teacher ({{teacher}}) is busy for this slot.',
      substitute: 'Substitute',
      substituteDesc: 'Take this slot with another available teacher.',
      skip: 'Later',
      skipDesc: 'Skip this slot. The lesson will be added later with your teacher.',
      searching: 'Searching for available teachers…',
      noSubs: 'No available teachers for this slot — pick "Later".',
      pickTeacher: '— pick a teacher —',
      pickSubstitute: 'Pick a substitute teacher',
      saving: 'Saving…',
      confirm: 'Confirm',
    },
    teacherLeave: {
      title: 'Decisions on lessons',
      teacherOnLeave: 'Your teacher will be unavailable',
      teacherOnLeaveVacation: 'Your teacher will be on vacation',
      teacherOnLeaveSick: 'Your teacher is on sick leave',
      teacherOnLeaveForceMajeure: 'Your teacher has a force majeure',
      teacherOnLeaveDayOff: 'Your teacher is taking a day off',
      needDecisionForLessons: 'Decision needed for {{count}} {{word}}: pause, substitute, or reschedule.',
      lessonOne: 'lesson',
      lessonMany: 'lessons',
      choose: 'Choose',
      teacher: 'Teacher',
      pause: 'Pause',
      pauseDesc: 'Skip the lesson. Credit is preserved, the program shifts.',
      substitute: 'Substitute',
      substituteDesc: 'Take the lesson with another teacher. The program continues.',
      reschedule: 'Reschedule',
      rescheduleDesc: 'Pick another free time with the same teacher. Free of charge.',
      searching: 'Searching for available teachers…',
      noSubs: 'No available teachers for this slot. Only pause is available.',
      pickTeacher: '— pick a teacher —',
      applyToRest: 'Apply to the remaining lessons of this leave',
      pickSubstitute: 'Pick a substitute teacher',
      saving: 'Saving…',
      confirm: 'Confirm',
    },
    lessonHistory: {
      title: 'Lesson history',
      filter: 'Filter',
      filterAll: 'All',
      filterIndividual: 'Individual',
      filterGroup: 'Group',
      empty: 'Lesson history is empty',
      minutes: 'min',
      teacher: 'Teacher',
      group: 'Group',
      individualLesson: 'Individual lesson',
      groupLesson: 'Group lesson',
      statusCompleted: 'Completed',
      statusScheduled: 'Scheduled',
      statusCancelledOnTime: 'Cancelled on time',
      statusCancelledLate: 'Cancelled late',
      statusCancelledNoFunds: 'Cancelled (insufficient funds)',
      statusMissed: 'Missed',
      statusTeacherNoShow: 'Teacher no-show',
      statusTeacherShort: 'Short lesson',
      statusBothNoShow: 'Both no-show',
      showing: 'Showing {{from}}-{{to}} of {{total}}',
      back: 'Back',
      forward: 'Forward',
    },
    shop: {
      title: 'Learning materials shop',
      searchPlaceholder: 'Search by name or SKU',
      filters: 'Filters',
      resetAll: 'Reset all',
      category: 'Category',
      topic: 'Topic',
      priceUah: 'Price (UAH)',
      priceFrom: 'From',
      priceTo: 'To',
      sort: 'Sort',
      sortDefault: 'Default',
      sortPriceAsc: 'Price: low to high',
      sortPriceDesc: 'Price: high to low',
      foundItems: 'Items found',
      catWorkbook: 'Workbook',
      catFlashcards: 'Flashcards',
      catMerch: 'Merch',
    },
    wishlist: {
      title: 'Wishlist',
      empty: 'Your wishlist is empty',
      emptyHint: 'Tap the heart on a product in the shop to add it here',
      goToShop: 'Go to shop',
      addToCart: 'Add to cart',
      currency: 'UAH',
    },
    childOffers: {
      determineLevel: 'Determine your level first',
      determineLevelDesc: 'Take the English level test to see personal recommendations',
      offersForYou: 'Offers for you',
      pickedForLevel: 'Specially picked for your level {{level}}',
      groupClasses: 'Group classes',
      groupsDesc: 'Study with peers',
      students: 'students',
      start: 'Start',
      individualLessons: 'Individual lessons',
      individualDesc: 'One-on-one lessons with a teacher',
      individualAsk: 'Want to study individually? Ask your parents to book a lesson!',
      learnMore: 'Learn more',
      learningMaterials: 'Learning materials',
      materialsDesc: 'Books and flashcards for learning',
      onlineCourses: 'Online courses',
      coursesDesc: 'Learn at your own pace',
      free: 'Free',
      noOffersYet: 'No special offers for your level yet',
      currency: 'UAH',
    },
    specialOffers: {
      title: 'Special offers',
      learnMore: 'Learn more',
    },
    childTopUp: {
      title: 'Top up balance',
      forChild: 'child',
      amount: 'Top-up amount',
      customAmount: 'Or enter an amount',
      pay: 'Pay',
      requisites: 'Payment details',
      cardNumber: 'Card number',
      cardholder: 'Recipient',
      bank: 'Bank',
      requisitesEmpty: 'Payment details have not been set up by admin yet',
      amountLbl: 'Amount',
      uploadReceipt: 'Upload the receipt or payment screenshot',
      fileHint: 'PNG, JPG up to 5MB',
      clickToUpload: 'Click to upload',
      delete: 'Delete',
      back: 'Back',
      uploading: 'Uploading...',
      paidBtn: 'I paid',
      approved: 'Payment confirmed!',
      approvedMsg: 'Payment confirmed! Child\'s balance has been updated.',
      rejected: 'Payment rejected',
      rejectedMsg: 'Payment was rejected.',
      pending: 'Payment is being verified',
      pendingMsg: 'Funds will be credited to the child\'s balance after admin verification.',
      loading: 'Loading...',
      tryAgain: 'Try again',
      close: 'Close',
      autoUpdate: 'Status updates automatically',
      closeWindowTitle: 'Close window?',
      closeWindowMsg: 'You have not completed the payment. Progress will be lost if you close. Are you sure?',
      continue: 'Continue',
      fileTooLarge: 'File is too large. Maximum size: 5MB',
      parentNotFound: 'Could not determine parent account. Please reload the page.',
      uploadError: 'File upload error',
      requestError: 'Error creating request',
      connectionError: 'Server connection error',
      error: 'Error',
      currency: 'UAH',
    },
    topUp: {
      title: 'Top up balance',
      amountLabel: 'Top-up amount',
      customAmount: 'Or enter an amount',
      payBtn: 'Pay',
      requisites: 'Payment details',
      cardNumber: 'Card number:',
      cardholder: 'Recipient:',
      bank: 'Bank:',
      requisitesEmpty: 'Payment details have not been set up by admin yet',
      amountLine: 'Amount: {{amount}} UAH',
      uploadReceipt: 'Upload the receipt or payment screenshot',
      fileHint: 'PNG, JPG up to 5MB',
      clickToUpload: 'Click to upload',
      delete: 'Delete',
      back: 'Back',
      uploading: 'Uploading...',
      paidBtn: 'I paid',
      approvedTitle: 'Payment confirmed!',
      rejectedTitle: 'Payment rejected',
      pendingTitle: 'Payment is being verified',
      approvedMsg: 'Payment confirmed! Balance updated.',
      rejectedDefault: 'Payment was rejected.',
      pendingMsg: 'Funds will be credited to the balance after admin verification.',
      loading: 'Loading...',
      amountInfo: 'Amount:',
      refreshBalance: 'Refresh balance',
      refreshing: 'Refreshing...',
      tryAgain: 'Try again',
      close: 'Close',
      autoUpdate: 'Status updates automatically',
      closeWindowTitle: 'Close window?',
      closeWindowMsg: 'You have not completed the payment. Progress will be lost if you close. Are you sure?',
      continueBtn: 'Continue',
      fileTooLarge: 'File is too large. Maximum size: 5MB',
      uploadError: 'File upload error',
      errorTitle: 'Error',
      currency: 'UAH',
    },
    clubs: {
      freeBookingTitle: 'Free club booking!',
      discountTitle: '{{discount}}% off clubs!',
      offerSubtitle: 'Pick any club with a discount',
      allClubs: 'All clubs',
      allLevels: 'All levels',
      levelStarter: 'A0 (Starter)',
      levelBeginner: 'A1 (Beginner)',
      levelElementary: 'A2 (Elementary)',
      levelIntermediate: 'B1 (Intermediate)',
      levelUpper: 'B2 (Upper-Intermediate)',
      levelAdvanced: 'C1 (Advanced)',
      clubsHistory: 'Club history',
      historyRecords: '{{count}} records',
      filterAll: 'All',
      filterBookings: 'Bookings',
      filterSubscriptions: 'Subscriptions',
      filterCancelled: 'Cancelled',
      noRecordsInCategory: 'No records in this category',
      subscriptionPurchased: 'Subscription purchased',
      subscriptionExhausted: 'Subscription exhausted',
      sessionsUsedAll: 'All sessions used',
      sessions4: '4 sessions',
      sessions8: '8 sessions',
      statusActive: 'Active',
      statusExpired: 'Expired',
      statusExhausted: 'Used up',
      club: 'Club',
      subscription: 'Subscription',
      upcomingClubs: 'Upcoming clubs',
      noScheduledClubs: 'No scheduled club sessions',
      spotsLeft: '{{spots}} spots left',
      noSpotsLeft: 'No spots left',
      audienceChild: 'Kids',
      audienceTeen: 'Teens',
      audienceAdult: 'Adults',
      free: 'Free',
      cancelBooking: 'Cancel',
      inReserve: 'On waitlist',
      cancelReserve: 'Cancel reservation',
      book: 'Book',
      reserve: 'Reserve',
      moreAboutClub: 'More about the club',
      subscriptionTitle: 'Subscription',
      subscriptionSubtitle: 'More affordable to attend clubs',
      buySubscription: 'Buy subscription',
      allClubsType: 'All clubs',
      remainingSessions: '{{count}} {{word}} left',
      sessionOne: 'session',
      sessionFew: 'sessions',
      sessionMany: 'sessions',
      validUntil: 'Valid until: {{date}}',
      pricesTitle: 'Club prices',
      singleSession: 'Single session',
      perSession: '{{price}} UAH/session',
      subscription30days: 'Subscription valid for 30 days from purchase',
      warning: 'Warning!',
      cancelBookingQuestion: 'Cancel booking?',
      cancelPromoWarning: 'This session was booked with a promo code. If you cancel — the promo code will be lost and won\'t be returned. Cancel "{{name}}" anyway?',
      cancelPenaltyWarning: 'Less than 4 hours until the session. On cancellation the money is not refunded.',
      cancelConfirmQuestion: 'Are you sure you want to cancel the booking for "{{name}}"?',
      no: 'No',
      yesCancel: 'Yes, cancel',
      confirm: 'Confirm',
      cancelling: 'Cancelling...',
      bookingConfirmation: 'Booking confirmation',
      alreadyBooked: 'You have already booked this club',
      notEnoughFunds: 'Not enough funds on balance',
      clubLbl: 'Club:',
      dateLbl: 'Date:',
      timeLbl: 'Time:',
      levelLbl: 'Level:',
      priceLbl: 'Price:',
      freePromo: 'Free (promo code)',
      bySubscription: 'By subscription',
      availableFreeClubs: '🎁 Free club sessions available:',
      havePromoCode: 'Have a promo code?',
      promoPlaceholder: 'BDAY-XXXXXXXX',
      activate: 'Activate',
      linkInSchedule: 'A link to the session will appear in the schedule',
      readAndAccept: 'I have read and accept the',
      termsOfService: 'Terms of Service',
      termsBookingSuffix: ', including the rules on payment, cancellation and refunds for club sessions.',
      cancel: 'Cancel',
      booking: 'Booking...',
      buySubTitle: 'Buy subscription',
      sessionsWord: 'sessions',
      buyBtn: 'Buy',
      subscription30line: 'Subscription valid for 30 days from purchase',
      reserveSpot: 'Reserve a spot',
      allSpotsTaken: 'All spots for this club are taken. You can reserve a spot — if someone cancels or admin adds spots, you will be automatically booked and notified.',
      freezeFunds: 'Funds hold:',
      oneSessionFromSub: '1 session from subscription',
      frozenReturnIfNotFree: 'Funds will be held and returned if the spot does not become free',
      termsReserveSuffix: ', including the rules on reservation, auto-booking and refund of held funds (section 5).',
      reserving: 'Reserving...',
      reserveBtn: 'Reserve',
      cancelReserveQuestion: 'Cancel reservation?',
      cancelReserveConfirm: 'Are you sure you want to cancel the reservation for "{{name}}"? Held funds will be returned.',
      detailsLevel: 'Level: {{level}}',
      descriptionLbl: 'Description',
      noDescription: 'No description',
      teacherLbl: 'Teacher',
      dateAndTime: 'Date and time',
      duration: 'Duration',
      minutes: 'min',
      spots: 'Spots',
      spotsOfTotal: '{{spots}} spots left of {{total}}',
      allTaken: 'All spots taken',
      price: 'Price',
      additionalInfo: 'Additional information',
      close: 'Close',
      promoNotForClub: 'This promo code is not for club sessions — activate it in the "Schedule" section.',
      promoActivated: 'Promo code activated: +{{count}} free club session',
      networkErrorRetry: 'Network error. Please try again.',
      couldNotActivate: 'Could not activate',
      bookingErrorGeneric: 'Booking error',
      statusBooked: 'Booked',
      statusAttended: 'Attended',
      statusCancelledOnTime: 'Cancelled on time',
      statusCancelledLate: 'Cancelled late',
      statusNoShow: 'No-show',
    },
    courses: {
      lessonsCount: '{{count}} lessons',
      lessons: 'lessons',
      purchased: 'Purchased',
      continue: 'Continue',
      free: 'Free',
      buy: 'Buy',
      enroll: 'Enroll',
      backToCourses: 'Back to courses',
      blocks: 'Blocks',
      level: 'Level',
      initialTest: 'Initial test',
      testResult: 'Result: {{score}} of {{total}} points',
      pointsOfTotal: '{{score}} of {{total}} points',
      takeTestBeforeStart: 'Take the test before starting the course',
      takeTest: 'Take test',
      startLearning: 'Start learning',
      buyCourse: 'Buy course',
      courseProgram: 'Course program',
      lessonsShort: '{{count}} lessons',
      stepsCount: '{{count}} steps',
      programNotFormed: 'Course program has not been created yet',
      purchaseConfirmation: 'Purchase confirmation',
      coursePrice: 'Course price:',
      yourBalance: 'Your balance:',
      notEnoughTopUpBy: 'Not enough funds. Top up your balance by {{amount}} UAH.',
      cancel: 'Cancel',
      confirmPurchase: 'Confirm purchase',
      coursePurchased: 'Course purchased!',
      canStartLearning: 'You can now start learning',
      continueBtn: 'Continue',
      goToMyCourses: 'Go to my courses',
      initialTestIntro: 'Before taking the course, please pass the test to record your starting result. This way we can understand which parts of the course to focus on and track your progress going forward.',
      questionsCount: '{{count}} questions',
      pointsCount: '{{count}} points',
      later: 'Later',
      startTest: 'Start test',
      taskOf: 'Task {{current}} of {{total}}',
      markAnswers: 'Mark your answers:',
      skip: 'Skip',
      next: 'Next',
      finishTest: 'Finish test',
      questionOf: 'Question {{current}} of {{total}}',
      back: 'Back',
      nextShort: 'Next',
      testCompleted: 'Test completed!',
      yourResult: 'Your result: {{score}} of {{total}} points',
      startTrainingBtn: 'Start learning',
      overview: 'Overview',
      video: 'Video',
      notes: 'Notes',
      exercise: 'Exercise',
      videoLoading: 'Loading video...',
      videoNotAdded: 'Video not added',
      notesEmpty: 'Notes are empty',
      exerciseTitle: 'Exercise',
      option: 'Option {{n}}',
      enterAnswer: 'Enter your answer...',
      correctAnswerLbl: 'Correct answer:',
      leftPart: 'Left part {{n}}',
      rightPart: 'Right part {{n}}',
      previousResult: 'Your previous result',
      result: 'Result:',
      tryImprove: 'You can try again to improve your result',
      tryAgain: 'Try again',
      checkAnswer: 'Check answer',
      previousStep: 'Previous step',
      nextStep: 'Next step',
      initialTestSubtitle: 'Take the test to determine your level and unlock the course',
      passTest: 'Take test',
      resultShort: 'Your result',
      courseProgress: 'Course progress',
      passedOf: '{{done}} of {{total}} lessons completed',
      completedLbl: 'Completed',
      completedLessons: 'Completed lessons',
      remainingLessons: 'Remaining',
      pickLessonHint: 'Pick a lesson on the left to continue learning',
      pickLessonFromList: 'Pick a lesson from the list',
      availableCourses: 'Available courses',
      myCourses: 'My courses',
      balance: 'Balance:',
      searchCourses: 'Search courses...',
      levelA1: 'A1 - Beginner',
      levelA2: 'A2 - Elementary',
      levelB1: 'B1 - Intermediate',
      levelB2: 'B2 - Upper-Intermediate',
      levelC1: 'C1 - Advanced',
      levelC2: 'C2 - Proficient',
      allLevels: 'All levels',
      noCoursesForQuery: 'No courses found for your query',
      noAvailableCourses: 'No available courses at the moment',
      noPurchasedYet: 'You have no purchased courses yet',
      viewAvailable: 'View available courses',
    },
    childMgmt: {
      insufficientChildFunds: 'Not enough funds on child\'s balance. Required: {{amount}} UAH, balance: {{balance}} UAH. Top up the balance.',
      paymentError: 'Payment error',
      connectionRetry: 'Connection error. Please try again later.',
      pickTeacherAndTime: 'Pick a teacher, days and lesson time',
      successEnrolled: 'Successfully enrolled! Payment will be deducted automatically at 450 UAH per lesson.',
      enrollError: 'Enrollment error',
      enrollRetry: 'Enrollment error. Please try again later.',
      pickGroup: 'Pick a group',
      groupLesson: 'Group lessons "{{name}}"',
      groupJoinError: 'Error joining group',
      clubLabel: 'Club "{{name}}"',
      clubBookError: 'Error booking club',
      nameEmpty: 'Name cannot be empty',
      ageInvalid: 'Enter a valid age',
      childDataUpdated: 'Child data updated',
      saveError: 'Error saving data',
      enterParentPassword: 'Enter your password',
      enterNewPassword: 'Enter a new password',
      passwordTooShort: 'Password must be at least 4 characters',
      passwordsDontMatch: 'Passwords do not match',
      passwordChangeError: 'Password change error',
      coursePurchase: 'Course "{{name}}"',
      yearsOldOf: '{{age}} years old',
      levelLbl: 'Level: {{level}}',
      testProgress: 'Test: {{done}}/7',
      testNotDone: 'Test not taken',
      topUpChildBalance: 'Top up child\'s balance',
      tabProgress: 'Progress',
      tabLearning: 'Learning',
      tabOffers: 'Offers',
      tabBalance: 'Balance',
      tabPermissions: 'Permissions',
      tabSettings: 'Settings',
      englishLevel: 'English level',
      passedOfTotal: '({{done}} of 7 completed)',
      testNotPassedYet: 'Level test has not been taken yet',
      individualLessonsTitle: 'Individual lessons',
      viewData: 'View details',
      enrollWithTeacher: 'Enroll in lessons with a teacher',
      groupLessonsTitle: 'Group lessons',
      enrollInGroup: 'Enroll in a learning group',
      availableCourses: 'Available courses',
      loadingCourses: 'Loading courses...',
      noCoursesAvailable: 'No available courses',
      coursesComingSoon: 'New courses will appear here soon',
      lessonsCountShort: '{{count}} lessons',
      enrolled: 'Enrolled',
      processing: 'Processing...',
      buy: 'Buy',
      free: 'Free',
      teacherLbl: 'Teacher',
      scheduleLbl: 'Schedule:',
      pricePerLesson: 'Price: {{price}} UAH per lesson',
      enrollToIndividual: 'Enroll in individual lessons',
      pickDays: 'Pick lesson days',
      timeFor: 'Time for {{day}}',
      pickTeacher: 'Pick a teacher',
      searchingTeachers: 'Searching for teachers...',
      noTeachersAvailable: 'Unfortunately, no teachers with free slots for the selected time',
      tryDifferentTime: 'Try picking a different time or days',
      oneLesson: 'One lesson:',
      priceAutoDeducted: 'Payment is deducted automatically for each lesson',
      enroll: 'Enroll',
      levelStudents: 'Level {{level}} • {{count}} students',
      availableGroups: 'Available groups (level {{level}})',
      loadingGroups: 'Loading groups...',
      noGroupsForLevel: 'No available groups for level {{level}}',
      tryIndividual: 'Try enrolling in individual lessons',
      scheduleTbd: 'Schedule to be confirmed',
      studentsCount: '{{current}}/{{max}} students',
      pricePerMonth: '{{price}} UAH/month',
      enrollToGroupPrice: 'Enroll in group for {{price}} UAH',
      clubs: 'Clubs',
      allClubs: 'All clubs',
      noScheduledClubs: 'No scheduled club sessions',
      spotsLbl: '{{spots}} spots',
      specialOffers: 'Special offers',
      personalizedForLevel: 'Personalised recommendations for level {{level}}',
      takeLevelTestFirst: 'Take the level test first',
      seePersonalized: 'To see personalised offers',
      matchingGroups: 'Matching groups by level',
      groupCountLine: '{{current}}/{{max}} students',
      individualLessons: 'Individual lessons',
      personalApproach: 'Personal approach to learning',
      individualEffective: 'Individual lessons with a teacher — the most effective way to learn English!',
      pricePerLessonLine: '{{price}} UAH/lesson',
      promotions: 'Promotions and discounts',
      specialProposals: 'Special offers',
      until: 'Until {{date}}',
      recommendedProducts: 'Recommended products',
      materialsForLevel: 'Learning materials for level {{level}}',
      onlineCourses: 'Online courses',
      selfStudy: 'Self-study',
      noOffersForLevel: 'No special offers for this level at the moment',
      currentBalance: 'Current balance',
      currentStars: 'Stars',
      topUp: 'Top up',
      transactionHistory: 'Transaction history',
      noTransactions: 'No transactions',
      pending: 'Pending',
      rejected: 'Rejected',
      childData: 'Child data',
      nameLbl: 'Name',
      enterName: 'Enter name',
      ageLbl: 'Age',
      enterAge: 'Enter age',
      nicknameLbl: 'Nickname',
      nicknameCannotChange: 'Nickname cannot be changed',
      birthdayLbl: 'Birthday',
      saving: 'Saving...',
      saveData: 'Save data',
      passwordLbl: 'Password',
      changePassword: 'Change password',
      parentPasswordLbl: 'Your password (parent)',
      enterYourPassword: 'Enter your password',
      newChildPassword: 'New child password',
      enterNewPasswordPh: 'Enter new password',
      confirmNewPassword: 'Confirm new password',
      repeatPassword: 'Repeat password',
      cancel: 'Cancel',
      save: 'Save',
      passwordChanged: 'Password changed',
      passwordSavedFor: 'New password for {{name}} has been saved',
      close: 'Close',
      bookingConfirmation: 'Booking confirmation',
      clubLbl: 'Club:',
      dateLbl: 'Date:',
      forLbl: 'For:',
      priceLbl: 'Price:',
      bookBtn: 'Book',
      successExclaim: 'Success!',
      atTime: 'at {{time}}',
    },
    learningSettings: {
      pickProgram: 'Pick a program',
      multipleProgramsHint: 'You have several learning programs. Pick the one you want to change the schedule for.',
      programFallback: 'Program',
      groupLearning: 'Group learning • {{teacher}}',
      individualLearning: 'Individual • {{teacher}}',
      teacherFallback: 'Teacher',
      fixedSchedule: 'Fixed schedule',
      groupLearningTitle: 'Group learning',
      groupScheduleFixed: 'Group class schedule is fixed and cannot be changed individually.',
      groupCurrentSchedule: 'Current group schedule:',
      dayAt: '{{day}} at {{time}}',
      groupContactAdmin: 'If the group schedule does not suit you, contact the administrator to transfer to a different group with a different schedule.',
      understood: 'Got it',
      takeVacation: 'Take vacation',
      pauseLessonsPeriod: 'Pause lessons for a period',
      changeLearningTime: 'Change learning time',
      pickAnotherTime: 'Pick a different time for lessons',
      changeTeacher: 'Change teacher',
      pickAnotherTeacher: 'Pick a different teacher',
      freezeLearning: 'Freeze learning',
      pauseIndefinite: 'Pause indefinitely',
      currentSettings: 'Current settings:',
      teacherLbl: 'Teacher:',
      scheduleLbl: 'Schedule:',
      progressLbl: 'Progress:',
      progressOf: '{{done}} of {{total}} lessons',
      vacationOncePerMonth: 'You can only take one vacation per month',
      nextVacationDate: 'Next vacation can be scheduled from {{date}}',
      vacationOverlap: 'There is already a vacation overlapping this period',
      whatIsVacation: 'What is a vacation?',
      vacationExplanation: 'During vacation, lessons are not held. After the vacation ends, learning continues on the same schedule, with the same teacher and from the same place in the program. Vacation can be scheduled for up to 2 weeks.',
      vacationStart: 'Vacation start date',
      vacationEnd: 'Vacation end date',
      vacationTooLong: 'Vacation is longer than 2 weeks. Please pick a shorter period.',
      processing: 'Processing...',
      createVacation: 'Schedule vacation',
      currentVacations: 'Current vacations:',
      vacationOngoing: 'Vacation is ongoing. Cannot be cancelled.',
      scheduledVacations: 'Scheduled vacations:',
      cancel: 'Cancel',
      changingSchedule: 'Schedule change',
      chooseDaysHint: 'Pick 1 to 7 days per week and a time for each day. All future lessons will be regenerated according to the new schedule.',
      changesUsed: 'Changes used this month: {{used}} of {{max}}',
      limitReached: 'You have reached the change limit for this month',
      programLbl: 'Program:',
      teacherLine: 'Teacher: {{name}}',
      currentTeacherLbl: 'Current teacher:',
      pickDaysHint: 'Pick lesson days (1-7):',
      teacherUnavailable: 'Teacher is unavailable on this day',
      timeForDay: 'Time for {{day}}:',
      noFreeSlots: 'No free slots',
      lessonsRegenerated: '{{count}} lessons will be regenerated according to the new schedule.',
      changingScheduleBtn: 'Changing schedule...',
      saveNewSchedule: 'Save new schedule',
      noSlotsAvail: 'No available slots',
      changeTeacherLink: 'Change teacher',
      changeTeacherTitle: 'Change teacher',
      changeTeacherHint: 'Pick a new teacher. Teachers who are free at a different time are marked separately — when picking them you\'ll also need to change the time.',
      availableTeachers: 'Available teachers:',
      changingTeacher: 'Changing teacher...',
      changeTeacherBtn: 'Change teacher',
      important: 'Important!',
      freezeExplanation: 'When freezing learning, all scheduled lessons will be paused. When you return to learning:',
      freezeReasonProgram: 'You will continue from the same place in the program',
      freezeReasonTeacher: 'The teacher may change',
      freezeReasonTime: 'Time and days of learning may change',
      freezeReasonPrice: 'Price may change according to current rates',
      yourCurrentProgress: 'Your current progress:',
      stopAtLesson: 'You will stop at lesson #{{lesson}}',
      understandFreeze: 'I understand that after unfreezing, the teacher, time and price may change',
      freezing: 'Freezing...',
      freezeBtn: 'Freeze learning',
      vacationSetUp: 'Vacation scheduled! {{count}} lessons will be skipped.',
      vacationCancelled: 'Vacation cancelled! {{count}} lessons restored.',
      studyFrozen: 'Learning frozen. {{count}} lessons paused.',
      scheduleChanged: 'Schedule changed! {{count}} lessons scheduled.',
      contactAdminForTeacher: 'Contact the administrator to change the teacher',
      requestSentToParent: 'Request sent to your parent. Wait for approval.',
      configureLearning: 'Configure learning',
    },
    adult: {
      teacherFallback: 'Teacher',
      clubTeacherFallback: 'Club teacher',
      lessonTypeIndividual: 'Individual lesson',
      lessonTypeGroup: 'Group lesson',
      chatTimeNow: 'Now',
      navProfile: 'Profile',
      navSchedule: 'Schedule',
      navClubs: 'Clubs',
      navChat: 'Chat',
      navAiChat: 'Practice with Ken',
      navAiChatShort: 'Ken',
      readerTitle: 'Reader — reading app',
      shopTitle: 'Shop',
      lightTheme: 'Light theme',
      darkTheme: 'Dark theme',
      loading: 'Loading...',
      balanceHistory: 'Balance history',
      transactionAt: '{{date}} at {{time}}',
      topupLabel: 'Top-up',
      lessonPayment: 'Lesson payment',
      currency: 'UAH',
      currentBalance: 'Current balance:',
      topupDescription: 'Balance top-up',
      lessonWithTeacher: 'Lesson with {{teacher}}',
      homeworkFallback: 'Homework',
      homeworkTitle: 'Homework',
      tabNew: 'New ({{count}})',
      tabOverdue: 'Overdue ({{count}})',
      tabCompleted: 'Completed ({{count}})',
      exercisesCount: '{{count}} exercises',
      pointsCount: '{{count}} points',
      deadline: 'Deadline: {{date}}',
      deadlineWas: 'Deadline was: {{date}}',
      doHomework: 'Do it',
      doHomeworkLate: 'Do it (will be submitted late)',
      overdueBadge: 'Overdue',
      submittedLateBadge: 'Submitted late',
      scoreLabel: 'Result: {{score}}',
      completedOn: 'Completed: {{date}}',
      viewHomework: 'View',
      emptyPending: 'No active homework',
      emptyOverdue: 'No overdue homework',
      emptyCompleted: 'No completed homework',
    },
  },
};

export default dict;
